export const REGULAR_GRADUATE_2026_2027 = [
  {
    college: 'Humanities and Social Sciences',
    department: 'Arabic Language and Literature',
    program: 'Master of Arts in Arabic Language',
    discipline: 'Literature and Criticism',
    requirements: `• Applicant must hold a full-time bachelor's degree in the Arabic language from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA, or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Arabic Language and Literature',
    program: 'Master of Arts in Arabic Language',
    discipline: 'Syntax and Language',
    requirements: `• Applicant must hold a full-time bachelor's degree in the Arabic language from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA, or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Arabic Language and Literature',
    program: 'PhD in Arabic Language and Literature',
    discipline: 'Literature and Criticism',
    requirements: `• Applicant must hold a full-time master's degree in the Arabic language and its literature (Literature and Criticism, Syntax and Language) from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Arabic Language and Literature',
    program: 'PhD in Arabic Language and Literature',
    discipline: 'Syntax and Language',
    requirements: `• Applicant must hold a full-time master's degree in the Arabic language and its literature (Literature and Criticism, Syntax and Language) from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'History',
    program: 'Master of Arts in History',
    discipline: 'Ancient History',
    requirements: `• Applicant must have a full-time bachelor's degree in history, or relevant disciplines; from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 25%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'History',
    program: 'Master of Arts in History',
    discipline: 'Islamic History',
    requirements: `• Applicant must have a full-time bachelor's degree in history, or relevant disciplines; from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 25%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'History',
    program: 'Master of Arts in History',
    discipline: 'Modern History',
    requirements: `• Applicant must have a full-time bachelor's degree in history, or relevant disciplines; from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 25%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'History',
    program: 'Master of Arts in National History of KSA',
    discipline: 'National History of KSA',
    requirements: `• Applicant must have a full-time bachelor's degree in history, or relevant disciplines; from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 25%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'History',
    program: 'PhD in History',
    discipline: 'Ancient History',
    requirements: `• Applicant must have a full-time master's degree in history or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 25%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'History',
    program: 'PhD in History',
    discipline: 'Islamic and Medieval History',
    requirements: `• Applicant must have a full-time master's degree in history or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 25%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'History',
    program: 'PhD in History',
    discipline: 'Modern and Contemporary History',
    requirements: `• Applicant must have a full-time master's degree in history or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 25%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Geography',
    program: 'Master of Arts in Geography',
    discipline: 'Environment and Natural Resources',
    requirements: `• Applicant must have a bachelor's degree (regular or distance) in geography or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Geography',
    program: 'Master of Arts in Geography',
    discipline: 'Sustainable Regional Development',
    requirements: `• Applicant must have a bachelor's degree (regular or distance) in geography or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Geography',
    program: 'Master of Arts in Geography',
    discipline: 'Maps',
    requirements: `• Applicant must have a bachelor's degree (regular or distance) in geography or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Geography',
    program: 'Master of Arts in Geography',
    discipline: 'Population and Development',
    requirements: `• Applicant must have a bachelor's degree (regular or distance) in geography or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Geography',
    program: 'Master of Arts in Geographical Information Systems',
    discipline: 'Geographical Information Systems',
    requirements: `• Applicant must have a bachelor's degree (regular or distance) in any humanities, scientific, engineering, or health disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; to identify the required discipline, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Geography',
    program: 'PhD in Geography',
    discipline: 'Human Geography',
    requirements: `• Applicant must hold a master's degree in geography or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submission a report of an English proficiency test.
• A score of at least 65 in the General Aptitude Test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Geography',
    program: 'PhD in Geography',
    discipline: 'Physical Geography',
    requirements: `• Applicant must hold a master's degree in geography or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submission a report of an English proficiency test.
• A score of at least 65 in the General Aptitude Test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Geography',
    program: 'PhD in Geography',
    discipline: 'Geographic Information Science',
    requirements: `• Applicant must hold a master's degree in geography or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submission a report of an English proficiency test.
• A score of at least 65 in the General Aptitude Test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Social Studies',
    program: 'Master of Arts in Sociology',
    discipline: 'Sociology',
    requirements: `• Applicant must hold a full-time bachelor's degree in sociology or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Social Studies',
    program: 'Master of Arts in Social Service',
    discipline: 'Social Service',
    requirements: `• Applicant must hold a full-time bachelor's degree in social service, or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Social Studies',
    program: 'PhD in Social Studies',
    discipline: 'Sociology',
    requirements: `• Applicant must hold a full-time master's degree in sociology, social service, psychology, education, anthropology, kindergarten, Business Administration, Islamic Sharia, law, mass communication from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA.
• Holders of an executive master's degree (a two-year program) who have an excellent CGPA (4.5/5 or equivalent) may be accepted, on the condition that their field of specialization is a direct continuation of their bachelor's and master's degrees and that they successfully complete any required complementary courses.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Social Studies',
    program: 'PhD in Social Studies',
    discipline: 'Social Service',
    requirements: `• Applicant must hold a full-time master's degree in sociology, social service, psychology, education, anthropology, kindergarten, Business Administration, Islamic Sharia, law, mass communication from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA.
• Holders of an executive master's degree (a two-year program) who have an excellent CGPA (4.5/5 or equivalent) may be accepted, on the condition that their field of specialization is a direct continuation of their bachelor's and master's degrees and that they successfully complete any required complementary courses.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Mass Communication',
    program: 'Master of Arts in Mass Communication',
    discipline: 'Mass Communication',
    requirements: `• Applicant must hold a full-time bachelor's degree in mass communication from KSU or any accredited university, with a minimum of an "very Good" (3.75/5) GPA or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Mass Communication',
    program: 'PhD in Communication and Digital Media',
    discipline: 'Communication and Digital Media',
    requirements: `• Applicant must hold a full-time master's degree in mass communication from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 3 in the IELTS- Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Information Science',
    program: 'Master of Arts in Information Science',
    discipline: 'Information Science',
    requirements: `• Applicant must hold a full-time bachelor's degree in information science or relevant disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Information Science',
    program: 'PhD in Information Science',
    discipline: 'Information Science',
    requirements: `• Applicant must hold a full-time master's degree in libraries, library and information science, information management, computers and information, IT, information systems, administrative information systems, health informatics, bioinformatics, data science, or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Submitting a personal statement in which the applicant reports his general interests and ambitions and research interests in the field.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Law and Political Science',
    department: 'Political Science',
    program: 'Master of Arts in Political Science',
    discipline: 'Political Science',
    requirements: `• Applicant must hold a full-time bachelor's degree in political science, or relevant disciplines, from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Law and Political Science',
    department: 'Public Law',
    program: 'Master of Law (Public Law)',
    discipline: 'Public Law',
    requirements: `• Applicant must hold a full-time bachelor's degree in law, rights, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Passing a written examination, with a minimum success score of 40%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Law and Political Science',
    department: 'Private Law',
    program: 'Master of Law (Private Law)',
    discipline: 'Private Law',
    requirements: `• Applicant must hold a full-time bachelor's degree in law, systems, Sharia, jurisprudence (Fiqh), judicial studies from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 70 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Law and Political Science',
    department: "Council of Joint Higher Diploma's Program in Intellectual Property",
    program: 'Higher Diploma in Intellectual Property',
    discipline: 'Intellectual Property',
    requirements: `• Applicant must hold a full-time bachelor's degree in law, or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Average Good" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 24,000',
  },
  {
    college: 'Law and Political Science',
    department: "Council of Joint PhD's Program in Law",
    program: 'PhD in Law',
    discipline: 'Law',
    requirements: `• Applicant must hold a full-time master's degree in law, regulations, or rights, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5.5 in the IELTS- Academic test or equivalent., or applicants must hold a degree from a country whose official language is English and the language of instruction was English, according to the approved deanship list.
• Submission of a "Statement of Purpose" explaining the applicant's PhD research interests.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Islamic Studies',
    program: 'Master of Islamic Studies',
    discipline: 'Jurisprudence (Fiqh) and its Fundamentals',
    requirements: `• Applicant must hold a full-time bachelor's degree in Islamic studies, jurisprudence (Fiqh) and its fundamentals, Sunnah and its sciences, creed, fundamentals of religion, comparative jurisprudence, Sharia, jurisdiction, Sharia policies, or related humanities disciplines from King Saud University or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicant must be memorizing five parts (juz') of the holy Qur'an (successively or non-successively).
• Passing a written examination held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Islamic Studies',
    program: 'Master of Islamic Studies',
    discipline: 'Creed',
    requirements: `• Applicant must hold a full-time bachelor's degree in Islamic studies, jurisprudence (Fiqh) and its fundamentals, Sunnah and its sciences, creed, fundamentals of religion, comparative jurisprudence, Sharia, jurisdiction, Sharia policies, or related humanities disciplines from King Saud University or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicant must be memorizing five parts (juz') of the holy Qur'an (successively or non-successively).
• Passing a written examination held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Islamic Studies',
    program: 'Master of Islamic Studies',
    discipline: 'Sunnah and its Sciences',
    requirements: `• Applicant must hold a full-time bachelor's degree in Islamic studies, jurisprudence (Fiqh) and its fundamentals, Sunnah and its sciences, creed, fundamentals of religion, comparative jurisprudence, Sharia, jurisdiction, Sharia policies, or related humanities disciplines from King Saud University or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicant must be memorizing five parts (juz') of the holy Qur'an (successively or non-successively).
• Passing a written examination held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Islamic Studies',
    program: 'PhD in Islamic Studies',
    discipline: 'Jurisprudence (Fiqh) and its Fundamentals',
    requirements: `• Applicant must hold a full-time master's degree in Islamic studies, jurisprudence (Fiqh) and its fundamentals, Sunnah and its sciences, creed, fundamentals of religion, comparative jurisprudence, Sharia, jurisdiction, Sharia policies, contemporary doctrines, or relevant disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent;
• Applicant must be memorizing ten parts (juz') of the holy Qur'an (successively or non-successively).
• Passing a written examination held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Islamic Studies',
    program: 'PhD in Islamic Studies',
    discipline: 'Creed',
    requirements: `• Applicant must hold a full-time master's degree in Islamic studies, jurisprudence (Fiqh) and its fundamentals, Sunnah and its sciences, creed, fundamentals of religion, comparative jurisprudence, Sharia, jurisdiction, Sharia policies, contemporary doctrines, or relevant disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent;
• Applicant must be memorizing ten parts (juz') of the holy Qur'an (successively or non-successively).
• Passing a written examination held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Islamic Studies',
    program: 'PhD in Islamic Studies',
    discipline: 'Sunnah and its Sciences',
    requirements: `• Applicant must hold a full-time master's degree in Islamic studies, jurisprudence (Fiqh) and its fundamentals, Sunnah and its sciences, creed, fundamentals of religion, comparative jurisprudence, Sharia, jurisdiction, Sharia policies, contemporary doctrines, or relevant disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent;
• Applicant must be memorizing ten parts (juz') of the holy Qur'an (successively or non-successively).
• Passing a written examination held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
// ... (previous entries up to Islamic Studies PhD)

  // ==================== Education: Psychology ====================
  {
    college: 'Education',
    department: 'Psychology',
    program: 'Master of Arts in Psychology',
    discipline: 'Social Psychology',
    requirements: `• Applicant must hold a full-time bachelor's degree in psychology or relevant disciplines (educational programs, statistics, mathematics, physics, computer science, business administration, social studies, political science, health rehabilitation, physical education and sport science) from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Psychology',
    program: 'Master of Arts in Psychology',
    discipline: 'Industrial Psychology',
    requirements: `• Applicant must hold a full-time bachelor's degree in psychology or relevant disciplines (educational programs, statistics, mathematics, physics, computer science, business administration, social studies, political science, health rehabilitation, physical education and sport science) from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Psychology',
    program: 'Master of Arts in Psychology',
    discipline: 'Developmental Psychology',
    requirements: `• Applicant must hold a full-time bachelor's degree in psychology or relevant disciplines (educational programs, statistics, mathematics, physics, computer science, business administration, social studies, political science, health rehabilitation, physical education and sport science) from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Psychology',
    program: 'Master of Arts in Psychology',
    discipline: 'Educational Psychology',
    requirements: `• Applicant must hold a full-time bachelor's degree in psychology or relevant disciplines (educational programs, statistics, mathematics, physics, computer science, business administration, social studies, political science, health rehabilitation, physical education and sport science) from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Psychology',
    program: 'Master of Arts in Psychology',
    discipline: 'Counselling Psychology',
    requirements: `• Applicant must hold a full-time bachelor's degree in psychology from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Psychology',
    program: 'Master of Arts in Psychology',
    discipline: 'Clinical Psychology',
    requirements: `• Applicant must hold a full-time bachelor's degree in psychology from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5 in the IELTS- Academic test or equivalent., or applicants must hold a degree from a country whose official language is English and the language of instruction was English, according to the approved deanship list.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties or submitting two recommendations from practitioners with the rank of senior psychologist or psychological consultant.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Psychology',
    program: 'PhD in Psychology',
    discipline: 'Socio-industrial Psychology',
    requirements: `• Applicant must hold a full-time master's degree in psychology from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 65 in the General Aptitude test or a score of 265 in the total of both sections of the GRE-General test.
• Passing a written examination with a minimum score of 50% held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Psychology',
    program: 'PhD in Psychology',
    discipline: 'Counselling Psychology',
    requirements: `• Applicant must hold a full-time master's degree in psychology from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 65 in the General Aptitude test or a score of 265 in the total of both sections of the GRE-General test.
• Passing a written examination with a minimum score of 50% held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Psychology',
    program: 'PhD in Psychology',
    discipline: 'Educational Psychology & Growth',
    requirements: `• Applicant must hold a full-time master's degree in psychology from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 65 in the General Aptitude test or a score of 265 in the total of both sections of the GRE-General test.
• Passing a written examination with a minimum score of 50% held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Education: Early Childhood ====================
  {
    college: 'Education',
    department: 'Early Childhood',
    program: 'Master of Arts in Early Childhood Education',
    discipline: 'Early Childhood Education',
    requirements: `• Applicant must hold a full-time bachelor's degree in early childhood education, preschool education (kindergarten) or related humanities disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Early Childhood',
    program: 'PhD in Early Childhood Education',
    discipline: 'Early Childhood Education',
    requirements: `• Applicant must hold a master's degree in early childhood education or any educational disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Education: Educational Policies ====================
  {
    college: 'Education',
    department: 'Educational Policies',
    program: 'Master of Arts in Education',
    discipline: 'Fundamentals of Education',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in any educational or non-educational discipline from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Educational Policies',
    program: 'Master of Arts in Education',
    discipline: 'Adult Education and Continuing Learning',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in any educational or non-educational discipline from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Educational Policies',
    program: 'Master of Arts in Educational Policies',
    discipline: 'Educational Policies',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in any educational or non-educational discipline from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Educational Policies',
    program: 'PhD in Education',
    discipline: 'Fundamentals of Education',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in any educational or non-educational disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination with a minimum score of 50% held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Educational Policies',
    program: 'PhD in Education',
    discipline: 'Adult Education and Continuing Learning',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in any educational or non-educational disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination with a minimum score of 50% held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Education: Educational Administration ====================
  {
    college: 'Education',
    department: 'Educational Administration',
    program: 'Master of Arts in Educational Administration',
    discipline: 'Educational Administration',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in any discipline from King Saud University or any accredited university, with a minimum of "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Educational Administration',
    program: 'PhD in Educational Administration',
    discipline: 'Public Education Administration',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in any educational or non-educational disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Educational Administration',
    program: 'PhD in Educational Administration',
    discipline: 'Higher Education administration',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in any educational or non-educational disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Education: Curriculum and Instruction ====================
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'Master of Arts in Education: Curriculum and Instruction',
    discipline: 'General Curriculum and Instruction',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'Master of Arts in Education: Curriculum and Instruction',
    discipline: 'Science Instruction',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'Master of Arts in Education: Curriculum and Instruction',
    discipline: 'Social Science Instruction',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'Master of Arts in Education: Curriculum and Instruction',
    discipline: 'Mathematics Instruction',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'Master of Arts in Education: Curriculum and Instruction',
    discipline: 'Islamic Sciences Instruction',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'Master of Arts in Education: Curriculum and Instruction',
    discipline: 'Arabic Language Instruction',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'Master of Arts in Education: Curriculum and Instruction',
    discipline: 'Computer Instruction',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'Master of Arts in Education: Curriculum and Instruction',
    discipline: 'Art Education Instruction',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'Master of Arts in Education: Curriculum and Instruction',
    discipline: 'Physical Education Instruction',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },

  // ==================== Education: TESOL ====================
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'Master of Arts in Education: TESOL',
    discipline: 'Teaching English for Speakers of Other Languages (TESOL)',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 5.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },

  // ==================== Education: Curriculum and Instruction PhD ====================
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'PhD in Education: Curriculum and Instruction',
    discipline: 'General Curriculum and Instruction',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'PhD in Education: Curriculum and Instruction',
    discipline: 'Science Instruction',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'PhD in Education: Curriculum and Instruction',
    discipline: 'Social Science Instruction',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'PhD in Education: Curriculum and Instruction',
    discipline: 'Mathematics Instruction',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'PhD in Education: Curriculum and Instruction',
    discipline: 'Curriculum and Instruction in Islamic Sciences',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Curriculum and Instruction',
    program: 'PhD in Education: Curriculum and Instruction',
    discipline: 'Computer Instruction',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in Curriculum and Instruction or relevant humanities, scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Education: Teaching Techniques ====================
  {
    college: 'Education',
    department: 'Teaching Techniques',
    program: 'Master of Arts in Teaching Techniques',
    discipline: 'Teaching Techniques',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in teaching techniques or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Teaching Techniques',
    program: 'PhD in Teaching Techniques',
    discipline: 'Teaching Techniques',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in teaching techniques, or any educational discipline, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; to identify the required discipline, applicant must refer to the concerned department before starting the application process.
• A score of at least 5.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum success score of 50%, held by the department.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // The array continues in the next response...
// ... (previous entries up to Teaching Techniques PhD)

  // ==================== Education: Special Education ====================
  {
    college: 'Education',
    department: 'Special Education',
    program: 'Master of Arts in Special Education',
    discipline: 'Behavioral and Emotional Disturbances',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in any disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Special Education',
    program: 'Master of Arts in Special Education',
    discipline: 'Learning Disabilities',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in any disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Special Education',
    program: 'Master of Arts in Special Education',
    discipline: 'Hearing Impairment',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in any disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Special Education',
    program: 'Master of Arts in Special Education',
    discipline: 'Intellectual Disability',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in any disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Special Education',
    program: 'PhD in Special Education',
    discipline: 'Behavioral and Emotional Disturbances',
    requirements: `• Applicant must hold a bachelor's degree in any disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Applicant must hold a full-time master's degree in any educational or non-educational discipline, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 40%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Special Education',
    program: 'PhD in Special Education',
    discipline: 'Learning Disabilities',
    requirements: `• Applicant must hold a bachelor's degree in any disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Applicant must hold a full-time master's degree in any educational or non-educational discipline, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 40%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Special Education',
    program: 'PhD in Special Education',
    discipline: 'Hearing Impairment',
    requirements: `• Applicant must hold a bachelor's degree in any disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Applicant must hold a full-time master's degree in any educational or non-educational discipline, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 40%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Special Education',
    program: 'PhD in Special Education',
    discipline: 'Intellectual Disability',
    requirements: `• Applicant must hold a bachelor's degree in any disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Applicant must hold a full-time master's degree in any educational or non-educational discipline, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 40%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Education: Qur'anic Studies ====================
  {
    college: 'Education',
    department: 'Qur\'anic Studies',
    program: 'Master of Arts in Qur\'anic Recitations',
    discipline: 'Qur\'anic Recitations',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in any discipline from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Memorization of the holy Qur'an.
• Mastering the seven Qur'anic readings (recitations) collectively or individually, With Quranic licenses attached.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Qur\'anic Studies',
    program: 'A Doctorate in Qur\'anic Studies: Recitations',
    discipline: 'Recitations',
    requirements: `• Applicant must hold a full-time master's degree in a Sharia-based or the Arabic language disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Mastering the fundamentals of the ten great Qur'anic recitations if the previous disciplines is not Recitations, With Quranic licenses attached.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Education',
    department: 'Qur\'anic Studies',
    program: 'Master of Arts in Tafseer (Qur\'anic Interpretation)',
    discipline: 'Tafseer (Qur\'anic Interpretation)',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in a Sharia-based or the Arabic language from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicant must be memorizing five consecutive parts (juz') of the holy Qur'an.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Education',
    department: 'Qur\'anic Studies',
    program: 'A Doctorate in Tafseer (Qur\'anic Interpretation)',
    discipline: 'Tafseer (Qur\'anic Interpretation)',
    requirements: `• Applicant must hold a full-time master's degree in Qur'anic studies or Qur'anic sciences from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Tourism and Archeology ====================
  {
    college: 'Tourism and Archeology',
    department: 'Archeology',
    program: 'Master of Arts in Archeology',
    discipline: 'Islamic Archeology',
    requirements: `• Applicant must hold a full-time bachelor's degree in Archeology or any relevant disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Tourism and Archeology',
    department: 'Archeology',
    program: 'Master of Arts in Archeology',
    discipline: 'Ancient Archeology',
    requirements: `• Applicant must hold a full-time bachelor's degree in Archeology or any relevant disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Tourism and Archeology',
    department: 'Archeology',
    program: 'PhD in Archeology',
    discipline: 'Islamic Era',
    requirements: `• Applicant must hold a full-time master's degree in Archeology or any relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Tourism and Archeology',
    department: 'Archeology',
    program: 'PhD in Archeology',
    discipline: 'Arabian Kingdoms',
    requirements: `• Applicant must hold a full-time master's degree in Archeology or any relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Tourism and Archeology',
    department: 'Archeology',
    program: 'PhD in Archeology',
    discipline: 'Inscriptions',
    requirements: `• Applicant must hold a full-time master's degree in Archeology or any relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Tourism and Archeology',
    department: 'Archeology',
    program: 'PhD in Archeology',
    discipline: 'The Pre-history of the Arabian Peninsula',
    requirements: `• Applicant must hold a full-time master's degree in Archeology or any relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Tourism and Archeology',
    department: 'Heritage Resources Management & Tourism Guidance',
    program: 'Master of Arts in Heritage Management',
    discipline: 'Heritage Management',
    requirements: `• Applicant must hold a full-time bachelor's degree in heritage resources management and tourism guidance or relevant disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Passing a written examination, with a minimum score of 40%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },

  // ==================== Sport Sciences and Physical Activity ====================
  {
    college: 'Sport Sciences and Physical Activity',
    department: 'Physical Education',
    program: 'Master of Arts in Physical Education',
    discipline: 'Physical Education',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in physical education or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Sport Sciences and Physical Activity',
    department: 'Exercise Physiology',
    program: 'MSc in Movement Sciences',
    discipline: 'Movement Sciences',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in sport sciences and physical activity or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Sport Sciences and Physical Activity',
    department: 'Biomechanics and Motor Behavior',
    program: 'MSc in Sports Training',
    discipline: 'Sports Training',
    requirements: `• Applicant must hold a full-time bachelor's degree in sport sciences and physical activity or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Sport Sciences and Physical Activity',
    department: 'Sports and Recreation Management',
    program: 'Master of Arts in Sports and Recreation Management',
    discipline: 'Sports and Recreation Management',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in sports and recreation management, sport sciences and physical activity, or relevant humanities, scientific disciplines; from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Sport Sciences and Physical Activity',
    department: 'Council of Joint PhD\'s Program in Sport Sciences and Physical Activity',
    program: 'PhD in Sport Sciences and Physical Activity',
    discipline: 'Physical Education',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in sports sciences or physical education, or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Holders of an executive master's degree (a two-year program) who have an excellent CGPA (4.5/5 or equivalent) may be accepted, on the condition that their field of specialization is a direct continuation of their bachelor's and master's degrees and that they successfully complete any required complementary courses.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Sport Sciences and Physical Activity',
    department: 'Council of Joint PhD\'s Program in Sport Sciences and Physical Activity',
    program: 'PhD in Sport Sciences and Physical Activity',
    discipline: 'Exercise Physiology',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in sports sciences or physical education, or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Holders of an executive master's degree (a two-year program) who have an excellent CGPA (4.5/5 or equivalent) may be accepted, on the condition that their field of specialization is a direct continuation of their bachelor's and master's degrees and that they successfully complete any required complementary courses.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Sport Sciences and Physical Activity',
    department: 'Council of Joint PhD\'s Program in Sport Sciences and Physical Activity',
    program: 'PhD in Sport Sciences and Physical Activity',
    discipline: 'Sports Training',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in sports sciences or physical education, or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Holders of an executive master's degree (a two-year program) who have an excellent CGPA (4.5/5 or equivalent) may be accepted, on the condition that their field of specialization is a direct continuation of their bachelor's and master's degrees and that they successfully complete any required complementary courses.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Sport Sciences and Physical Activity',
    department: 'Council of Joint PhD\'s Program in Sport Sciences and Physical Activity',
    program: 'PhD in Sport Sciences and Physical Activity',
    discipline: 'Sports and Recreation Management',
    requirements: `• Applicant must hold a master's degree (regular or distance learning) in sports sciences or physical education, or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Holders of an executive master's degree (a two-year program) who have an excellent CGPA (4.5/5 or equivalent) may be accepted, on the condition that their field of specialization is a direct continuation of their bachelor's and master's degrees and that they successfully complete any required complementary courses.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Language Sciences ====================
  {
    college: 'Language Sciences',
    department: 'French Language',
    program: 'Master of Arts in Translation Studies (French Language)',
    discipline: 'Translation Studies (French Language)',
    requirements: `• Applicant must hold a full-time bachelor's degree in French, or relevant humanity disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• The applicant has complete proficiency in the French language, both written and spoken.
• Applicant must be medically fit as regards hearing, sight, and speech.
• Passing a written examination in French held by the department, with a minimum score of 50%.`,
    language: 'French',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Language Sciences',
    department: 'English Language',
    program: 'Higher Diploma in Legal Translation',
    discipline: 'Legal Translation',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in the English language, law, rights, or systems from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent.
• The applicant has complete proficiency in the Arabic language, both written and spoken.
• A score of at least 5.5 in the IELTS-Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 24,000',
  },
  {
    college: 'Language Sciences',
    department: 'English Language',
    program: 'Master of Arts in Translation (English Language)',
    discipline: 'Translation (English Language)',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in English or relevant humanity disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 6.5 in Academic IELTS Academic or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Language Sciences',
    department: 'English Language',
    program: 'Master of Arts in English Literature',
    discipline: 'English Literature',
    requirements: `• Applicant must hold a full-time bachelor's degree in English or relevant humanity disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) or equivalent.; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 6 in IELTS Academic or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Language Sciences',
    department: 'English Language',
    program: 'Master of Arts in Applied Linguistics',
    discipline: 'Applied Linguistics',
    requirements: `• Applicant must hold a full-time bachelor's degree in English language linguistics/linguistics, applied linguistics, theoretical linguistics, modern linguistics, English language translation specialization, English educational specialization - teaching English to non-native speakers - methods of teaching the English language - Speech and hearing therapy or relevant humanity disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 6.5 in IELTS Academic or equivalent.
• Passing a written examination held by the department, with a minimum score of 50%.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Language Sciences',
    department: 'English Language',
    program: 'PhD in Applied Linguistics',
    discipline: 'Applied Linguistics',
    requirements: `• Applicant must hold a full-time master's degree in English language, linguistics/linguistics, applied linguistics, theoretical linguistics, modern linguistics, English language translation specialization, teaching English to non-native speakers - methods of teaching English, or relevant humanity disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 7 in IELTS Academic or equivalent.
• Passing a written examination held by the department, with a minimum score of 50%.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Language Sciences',
    department: 'Linguistics',
    program: 'Master of Arts in Theoretical Linguistics',
    discipline: 'Theoretical Linguistics',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in Linguistics, English, Arabic, computer science, psychology, or relevant disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5.5 in the IELTS Academic or equivalent.
• Passing a written examination held by the department.
• Submitting a research proposal pointing out the purpose of the study.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Language Sciences',
    department: 'Linguistics',
    program: 'PhD in Linguistics',
    discipline: 'Linguistics',
    requirements: `• Applicant must hold a full-time master's degree in linguistics, applied linguistics, English, Arabic, or a related discipline from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) CGPA or equivalent. For related disciplines, the applicant must consult the concerned department before applying through the electronic portal.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Submission of a Statement of Purpose.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 1000,000',
  },
  {
    college: 'Language Sciences',
    department: 'Arabic Studies (Second Language)',
    program: 'Higher Diploma for Training Teachers of Arabic to Non-native Speakers',
    discipline: 'Training Teachers of Arabic to Non-native Speakers',
    requirements: `• Applicant must hold a full-time bachelor's degree in Arabic language or Islamic studies from KSU or any accredited university, with (2/5) GPA or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR24,000',
  },
  {
    college: 'Language Sciences',
    department: 'Arabic Studies (Second Language)',
    program: 'Master of Arts in Teaching Arabic as a Second Language',
    discipline: 'Teaching Arabic to Non-native Speakers',
    requirements: `• Applicant must hold a full-time bachelor's degree in Arabic language, Related humanities disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• The English language discipline may be accepted, provided that the applicant must be a native speaker of Arabic.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Language Sciences',
    department: 'Arabic Studies (Second Language)',
    program: 'Master of Arts in Developing Skills of Teachers of Arabic as a Second Language',
    discipline: 'Developing Skills of Teachers of Arabic as a Second Language',
    requirements: `• Applicant must hold a full-time bachelor's degree in Arabic language or Islamic studies from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Language Sciences',
    department: 'Arabic Studies (Second Language)',
    program: 'PhD in Arabic Applied Linguistics',
    discipline: 'Arabic Applied Linguistics',
    requirements: `• Applicant must hold a master's degree in Arabic applied linguistics, English applied linguistics, Related humanities disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Applicant having a master's degree in English applied linguistics may be accepted, provided that the applicant must be a native speaker of Arabic.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Architecture and Planning ====================
  {
    college: 'Architecture and Planning',
    department: 'Urban Planning',
    program: 'MSc in Urban Planning',
    discipline: 'Urban Planning',
    requirements: `• Applicant must hold a full-time bachelor's degree (a minimum of 4 years) in urban planning, urban design, environmental architecture, architecture, interior design, or All specializations of the College of Engineering, from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Architecture and Planning',
    department: 'Urban Planning',
    program: 'MSc in Urban Design',
    discipline: 'Urban Design',
    requirements: `• Applicant must hold a full-time bachelor's degree (a minimum of 4 years) in urban planning, urban design, environmental architecture, architecture, interior design, from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Architecture and Planning',
    department: 'Urban Planning',
    program: 'MSc in Real Estate Development',
    discipline: 'Real Estate Development',
    requirements: `• Applicant must hold a full-time bachelor's degree (a minimum of 4 years) in urban planning, urban design, environmental architecture, architecture, interior design, all specializations of the College of Engineering, Computers and Information, and a bachelor's degree in business administration in all its specializations from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Architecture and Planning',
    department: 'Urban Planning',
    program: 'PhD in Urban Studies and Planning',
    discipline: 'Urban Studies and Planning',
    requirements: `• Applicant must have a full-time master's degree in urban planning, urban design, real estate development, environmental architecture or architecture from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) CGPA or equivalent.
• Holders of an executive master's degree (a two-year program) in municipal policy and city development with a minimum of an "Excellent" (4.5/5) CGPA or equivalent may be accepted, on the condition that their field of specialization is a direct continuation of their bachelor's and master's degrees and that they successfully complete any required complementary courses.
• Submission of a Statement of Purpose.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Architecture and Planning',
    department: 'Architecture and Building Sciences',
    program: 'MSc in Architecture and Building Sciences',
    discipline: 'Architecture and Building Sciences',
    requirements: `• Applicant must hold a full-time bachelor's degree in architecture, architectural engineering, interior architecture, interior design, urban planning, urban design, or relevant scientific disciplines, from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'Arabic- English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Architecture and Planning',
    department: 'Architecture and Building Sciences',
    program: 'PhD in Architecture and Building Sciences',
    discipline: 'Architecture and Building Sciences',
    requirements: `• Applicant must hold a full-time bachelor's degree (at least 5 years) in architecture, architectural engineering, interior architecture from KSU or any accredited university, with a minimum of an "Above Average" (3.25 / 5) GPA or equivalent.
• Applicant must hold a full-time master's degree in architecture, architectural engineering, architectural planning and design, interior architecture, project management, or environmental architecture, from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Submitting a statement of purpose for the study. It should be around 500 words long.`,
    language: 'Arabic- English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Engineering: Civil Engineering ====================
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'MSc in Civil Engineering',
    discipline: 'Construction Engineering and Management',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering or relevant scientific, health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Environmental Engineering track only, with the study of complementary courses.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'MSc in Civil Engineering',
    discipline: 'Water Resources Engineering',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering or relevant scientific, health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Environmental Engineering track only, with the study of complementary courses.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'MSc in Civil Engineering',
    discipline: 'Environmental Engineering',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering or relevant scientific, health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Environmental Engineering track only, with the study of complementary courses.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'MSc in Civil Engineering',
    discipline: 'Structural Engineering',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering or relevant scientific, health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Environmental Engineering track only, with the study of complementary courses.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'MSc in Civil Engineering',
    discipline: 'Geotechnical Engineering',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering or relevant scientific, health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Environmental Engineering track only, with the study of complementary courses.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'MSc in Civil Engineering',
    discipline: 'Transportation Engineering',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering or relevant scientific, health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Environmental Engineering track only, with the study of complementary courses.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'PhD in Civil Engineering',
    discipline: 'Construction Engineering and Management',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent.
• Applicant must hold a full-time master's degree in civil engineering, Construction Engineering and Management, Water Resources, Environmental Engineering, Structural Engineering, Geotechnical Engineering from KSU or any accredited university, with a minimum of "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'PhD in Civil Engineering',
    discipline: 'Water Resources',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent.
• Applicant must hold a full-time master's degree in civil engineering, Construction Engineering and Management, Water Resources, Environmental Engineering, Structural Engineering, Geotechnical Engineering from KSU or any accredited university, with a minimum of "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'PhD in Civil Engineering',
    discipline: 'Environmental Engineering',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent.
• Applicant must hold a full-time master's degree in civil engineering, Construction Engineering and Management, Water Resources, Environmental Engineering, Structural Engineering, Geotechnical Engineering from KSU or any accredited university, with a minimum of "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'PhD in Civil Engineering',
    discipline: 'Structural Engineering',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent.
• Applicant must hold a full-time master's degree in civil engineering, Construction Engineering and Management, Water Resources, Environmental Engineering, Structural Engineering, Geotechnical Engineering from KSU or any accredited university, with a minimum of "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'PhD in Civil Engineering',
    discipline: 'Geotechnical Engineering',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent.
• Applicant must hold a full-time master's degree in civil engineering, Construction Engineering and Management, Water Resources, Environmental Engineering, Structural Engineering, Geotechnical Engineering from KSU or any accredited university, with a minimum of "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Civil Engineering',
    program: 'PhD in Civil Engineering',
    discipline: 'Transportation Engineering',
    requirements: `• Applicant must hold a full-time BSc. in civil engineering from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) GPA or equivalent.
• Applicant must hold a full-time master's degree in civil engineering, Construction Engineering and Management, Water Resources, Environmental Engineering, Structural Engineering, Geotechnical Engineering from KSU or any accredited university, with a minimum of "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },

  // The array continues in the next response with Chemical Engineering, Electrical Engineering, etc.
// ... (previous entries up to Civil Engineering PhD)

  // ==================== Engineering: Chemical Engineering ====================
  {
    college: 'Engineering',
    department: 'Chemical Engineering',
    program: 'MSc in Chemical Engineering',
    discipline: 'Chemical Engineering',
    requirements: `• Applicant must hold a full-time BSc. in chemical engineering from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent, provided that the student's GPA of the specialty courses (chemical engineering) at the bachelor's stage is at least "Very Good" (3.75 / 5) or equivalent.
• Applicant holding a bachelor's degree in other relevant engineering, scientific disciplines with a minimum of a "Very Good" (3.75/5) GPA or equivalent may be accepted.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent, except applicant who hold an engineering degree from King Saud University.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Chemical Engineering',
    program: 'MSc in Polymer Engineering',
    discipline: 'Polymer Engineering',
    requirements: `• Applicant must hold a full-time BSc. in chemical engineering from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent, provided that the student's GPA of the specialty courses (chemical engineering) at the bachelor's stage is at least "Very Good" (3.75 / 5) or equivalent.
• Applicant holding a bachelor's degree in other relevant engineering, scientific disciplines with a minimum of a "Very Good" (3.75/5) GPA or equivalent may be accepted.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent, except applicant who hold an engineering degree from King Saud University.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Chemical Engineering',
    program: 'PhD in Chemical Engineering',
    discipline: 'Chemical Industries',
    requirements: `• Applicant must hold a full-time master's degree in chemical engineering or equivalent from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS Academic test or equivalent, except applicant who hold an engineering degree from King Saud University.
• A score of at least 65 in the Quantitative section of the General Aptitude Test or 144 in the Quantitative section of the GRE-General test.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Chemical Engineering',
    program: 'PhD in Chemical Engineering',
    discipline: 'Process Synthesis and Control',
    requirements: `• Applicant must hold a full-time master's degree in chemical engineering or equivalent from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS Academic test or equivalent, except applicant who hold an engineering degree from King Saud University.
• A score of at least 65 in the Quantitative section of the General Aptitude Test or 144 in the Quantitative section of the GRE-General test.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Chemical Engineering',
    program: 'PhD in Chemical Engineering',
    discipline: 'Materials Engineering',
    requirements: `• Applicant must hold a full-time master's degree in chemical engineering or equivalent from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS Academic test or equivalent, except applicant who hold an engineering degree from King Saud University.
• A score of at least 65 in the Quantitative section of the General Aptitude Test or 144 in the Quantitative section of the GRE-General test.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Chemical Engineering',
    program: 'PhD in Chemical Engineering',
    discipline: 'Transport Phenomena',
    requirements: `• Applicant must hold a full-time master's degree in chemical engineering or equivalent from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS Academic test or equivalent, except applicant who hold an engineering degree from King Saud University.
• A score of at least 65 in the Quantitative section of the General Aptitude Test or 144 in the Quantitative section of the GRE-General test.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },

  // ==================== Engineering: Electrical Engineering ====================
  {
    college: 'Engineering',
    department: 'Electrical Engineering',
    program: 'MSc in Electrical Engineering',
    discipline: 'Electronics',
    requirements: `• Applicant must hold a full-time BSc. in electrical engineering or relevant scientific disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25 / 5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Electrical Engineering',
    program: 'MSc in Electrical Engineering',
    discipline: 'Communications',
    requirements: `• Applicant must hold a full-time BSc. in electrical engineering or relevant scientific disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25 / 5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Electrical Engineering',
    program: 'MSc in Electrical Engineering',
    discipline: 'Control Systems and Computer',
    requirements: `• Applicant must hold a full-time BSc. in electrical engineering or relevant scientific disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25 / 5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Electrical Engineering',
    program: 'MSc in Electrical Engineering',
    discipline: 'Electrical Power',
    requirements: `• Applicant must hold a full-time BSc. in electrical engineering or relevant scientific disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25 / 5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Electrical Engineering',
    program: 'PhD in Electrical Engineering',
    discipline: 'Electronics',
    requirements: `• Applicant must hold a full-time bachelor's degree BSc. in engineering from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Applicant must hold a full-time master's degree in electrical engineering or relevant scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS Academic test or equivalent.
• A score of at least 151 in the Quantitative section of the GRE-General test. Except applicant who hold a full-time master's degree in electrical engineering from King Saud University with a minimum of (4.25/5) within the last two years.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Electrical Engineering',
    program: 'PhD in Electrical Engineering',
    discipline: 'Communications',
    requirements: `• Applicant must hold a full-time bachelor's degree BSc. in engineering from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Applicant must hold a full-time master's degree in electrical engineering or relevant scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS Academic test or equivalent.
• A score of at least 151 in the Quantitative section of the GRE-General test. Except applicant who hold a full-time master's degree in electrical engineering from King Saud University with a minimum of (4.25/5) within the last two years.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Electrical Engineering',
    program: 'PhD in Electrical Engineering',
    discipline: 'Automatic Control and Computers',
    requirements: `• Applicant must hold a full-time bachelor's degree BSc. in engineering from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Applicant must hold a full-time master's degree in electrical engineering or relevant scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS Academic test or equivalent.
• A score of at least 151 in the Quantitative section of the GRE-General test. Except applicant who hold a full-time master's degree in electrical engineering from King Saud University with a minimum of (4.25/5) within the last two years.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Electrical Engineering',
    program: 'PhD in Electrical Engineering',
    discipline: 'Electrical Power',
    requirements: `• Applicant must hold a full-time bachelor's degree BSc. in engineering from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Applicant must hold a full-time master's degree in electrical engineering or relevant scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS Academic test or equivalent.
• A score of at least 151 in the Quantitative section of the GRE-General test. Except applicant who hold a full-time master's degree in electrical engineering from King Saud University with a minimum of (4.25/5) within the last two years.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Engineering: Mechanical Engineering ====================
  {
    college: 'Engineering',
    department: 'Mechanical Engineering',
    program: 'MSc in Mechanical Engineering',
    discipline: 'Solid Mechanics',
    requirements: `• Applicant must hold a full-time BSc. in mechanical engineering from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent, provided that applicant's GPA of the specialty courses (mechanical engineering) is at least "Very Good" (3.75/5) GPA or equivalent.
• Applicant holding a bachelor's degree in other engineering disciplines with a minimum of a "Very Good" (3.75/5) GPA or equivalent may be accepted; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent., except applicant who hold an engineering degree from King Saud University.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Mechanical Engineering',
    program: 'MSc in Mechanical Engineering',
    discipline: 'Refractories and Fluids',
    requirements: `• Applicant must hold a full-time BSc. in mechanical engineering from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent, provided that applicant's GPA of the specialty courses (mechanical engineering) is at least "Very Good" (3.75/5) GPA or equivalent.
• Applicant holding a bachelor's degree in other engineering disciplines with a minimum of a "Very Good" (3.75/5) GPA or equivalent may be accepted; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent., except applicant who hold an engineering degree from King Saud University.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Mechanical Engineering',
    program: 'MSc in Material Engineering',
    discipline: 'Material Engineering',
    requirements: `• Applicant must hold a full-time BSc. in material engineering, mechanical engineering from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent, provided that applicant's GPA of the specialty courses (material engineering or mechanical engineering) is at least "Very Good" (3.75/5) GPA or equivalent.
• Applicant holding a bachelor's degree in other engineering disciplines with a minimum of a "Very Good" (3.75/5) GPA or equivalent might be accepted; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent., except applicant who hold an engineering degree from King Saud University.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Mechanical Engineering',
    program: 'PhD in Mechanical Engineering',
    discipline: 'Solid Mechanics',
    requirements: `• Applicant must hold a full-time BSc. in mechanical engineering from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent, provided that applicant's GPA of the specialty courses (mechanical engineering) is at least "Very Good" (3.75/5) GPA or equivalent.
• Applicant holding a bachelor's degree in other engineering disciplines with a minimum of a "Very Good" (3.75/5) GPA or equivalent might be accepted; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicant must hold a full-time master's degree in mechanical engineering or relevant engineering disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process
• A score of at least 6 in the IELTS Academic test or equivalent., except applicant who hold an engineering degree from King Saud University.
• A score of at least 75 in the Qiyas General Aptitude test (Quantitative section) or at least 148 in the GRE-General (Quantitative section) test.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Mechanical Engineering',
    program: 'PhD in Mechanical Engineering',
    discipline: 'Refractories and Fluids',
    requirements: `• Applicant must hold a full-time BSc. in mechanical engineering from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent, provided that applicant's GPA of the specialty courses (mechanical engineering) is at least "Very Good" (3.75/5) GPA or equivalent.
• Applicant holding a bachelor's degree in other engineering disciplines with a minimum of a "Very Good" (3.75/5) GPA or equivalent might be accepted; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicant must hold a full-time master's degree in mechanical engineering or relevant engineering disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process
• A score of at least 6 in the IELTS Academic test or equivalent., except applicant who hold an engineering degree from King Saud University.
• A score of at least 75 in the Qiyas General Aptitude test (Quantitative section) or at least 148 in the GRE-General (Quantitative section) test.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },

  // ==================== Engineering: Industrial Engineering ====================
  {
    college: 'Engineering',
    department: 'Industrial Engineering',
    program: 'MSc in Industrial Engineering',
    discipline: 'Manufacturing Systems',
    requirements: `• Applicant must hold a full-time BSc. in engineering, safety and occupational health science, computer science, IT, information systems, or relevant scientific, health disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Human Systems Engineering track only, and applicants from computer science specialties are limited to the Industrial Systems track only.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Industrial Engineering',
    program: 'MSc in Industrial Engineering',
    discipline: 'Industrial Systems',
    requirements: `• Applicant must hold a full-time BSc. in engineering, safety and occupational health science, computer science, IT, information systems, or relevant scientific, health disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Human Systems Engineering track only, and applicants from computer science specialties are limited to the Industrial Systems track only.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Industrial Engineering',
    program: 'MSc in Industrial Engineering',
    discipline: 'Human Systems',
    requirements: `• Applicant must hold a full-time BSc. in engineering, safety and occupational health science, computer science, IT, information systems, or relevant scientific, health disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Human Systems Engineering track only, and applicants from computer science specialties are limited to the Industrial Systems track only.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Industrial Engineering',
    program: 'PhD in Industrial Engineering',
    discipline: 'Manufacturing Systems Engineering',
    requirements: `• Applicant must hold a full-time BSc. from King Saud University or any accredited university.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• Applicant must hold a full-time master's degree in industrial engineering, manufacturing engineering, or production engineering or relevant scientific, health disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Human Factors and Safety Engineering track only, and applicants from computer science specialties are limited to the Industrial Systems track only.
• A score of at least 6 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Industrial Engineering',
    program: 'PhD in Industrial Engineering',
    discipline: 'Human Factors and Safety Engineering',
    requirements: `• Applicant must hold a full-time BSc. from King Saud University or any accredited university.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• Applicant must hold a full-time master's degree in industrial engineering, manufacturing engineering, or production engineering or relevant scientific, health disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Human Factors and Safety Engineering track only, and applicants from computer science specialties are limited to the Industrial Systems track only.
• A score of at least 6 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Engineering',
    department: 'Industrial Engineering',
    program: 'PhD in Industrial Engineering',
    discipline: 'Industrial Systems and Supply Chain Engineering',
    requirements: `• Applicant must hold a full-time BSc. from King Saud University or any accredited university.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• Applicant must hold a full-time master's degree in industrial engineering, manufacturing engineering, or production engineering or relevant scientific, health disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicants from health specialties are limited to the Human Factors and Safety Engineering track only, and applicants from computer science specialties are limited to the Industrial Systems track only.
• A score of at least 6 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Engineering: Petroleum and Natural Gas Engineering ====================
  {
    college: 'Engineering',
    department: 'Petroleum and Natural Gas Engineering',
    program: 'MSc in Petroleum and Natural Gas Engineering',
    discipline: 'Well Drilling Engineering',
    requirements: `• Applicant must hold a full-time BSc. in petroleum and natural gas engineering, chemical engineering, electrical engineering, mechanical engineering, geology, geophysics, or relevant engineering, scientific disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicant with "Good" (3/5) GPA might be accepted with at least 3 years of field experience.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Petroleum and Natural Gas Engineering',
    program: 'MSc in Petroleum and Natural Gas Engineering',
    discipline: 'Petroleum Production Engineering',
    requirements: `• Applicant must hold a full-time BSc. in petroleum and natural gas engineering, chemical engineering, electrical engineering, mechanical engineering, geology, geophysics, or relevant engineering, scientific disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicant with "Good" (3/5) GPA might be accepted with at least 3 years of field experience.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Petroleum and Natural Gas Engineering',
    program: 'MSc in Petroleum and Natural Gas Engineering',
    discipline: 'Petroleum Reservoir Engineering',
    requirements: `• Applicant must hold a full-time BSc. in petroleum and natural gas engineering, chemical engineering, electrical engineering, mechanical engineering, geology, geophysics, or relevant engineering, scientific disciplines from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Applicant with "Good" (3/5) GPA might be accepted with at least 3 years of field experience.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },

  // ==================== Engineering: Council of Joint Master's Program in Water Desalination Engineering ====================
  {
    college: 'Engineering',
    department: 'Council of Joint Master\'s Program in Water Desalination Engineering',
    program: 'MSc in Water Desalination Engineering',
    discipline: 'Water Desalination Engineering',
    requirements: `• Applicant must hold a full-time BSc. in mechanical engineering, chemical engineering, or any engineering discipline from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; provided that applicant's GPA of the specialty courses (chemical engineering or mechanical engineering) is at least "Very Good" (3.75/5) GPA or equivalent. for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Completing a minimum of 30 credit hours of basic sciences (mathematics, physics, statistics, chemistry) at the undergraduate level, in addition to 45 credit hours of engineering courses.
• A score of at least 5 in the IELTS Academic test or equivalent; except applicant who hold an engineering degree from King Saud University.`,
    language: 'English',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },

  // ==================== Engineering: Council of Joint Master's Program in Nuclear Engineering ====================
  {
    college: 'Engineering',
    department: 'Council of Joint Master\'s Program in Nuclear Engineering',
    program: 'MSc in Nuclear Engineering',
    discipline: 'Nuclear Reactor Engineering',
    requirements: `• Applicant must hold a full-time BSc. in engineering disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant engineering disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Engineering',
    department: 'Council of Joint Master\'s Program in Nuclear Engineering',
    program: 'MSc in Nuclear Engineering',
    discipline: 'Nuclear Radiation Engineering',
    requirements: `• Applicant must hold a full-time BSc. in engineering disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant engineering disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },

  // ==================== Science: Botany and Microbiology ====================
  {
    college: 'Science',
    department: 'Botany and Microbiology',
    program: 'MSc in Botany',
    discipline: 'Botany',
    requirements: `• Applicant must hold a full-time bachelor's degree in botany from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Relevant scientific and health disciplines might be accepted with at least "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Botany and Microbiology',
    program: 'MSc in Microbiology',
    discipline: 'Microbiology',
    requirements: `• Applicant must hold a full-time bachelor's degree in microbiology from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Relevant scientific and health disciplines might be accepted with at least "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Botany and Microbiology',
    program: 'PhD Botany',
    discipline: 'Botany',
    requirements: `• Applicant must hold a full-time master's degree in botany or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Submitting a report of English proficiency test result.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Science',
    department: 'Botany and Microbiology',
    program: 'PhD in Microbiology',
    discipline: 'Microbiology',
    requirements: `• Applicant must hold a full-time master's degree in microbiology or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submitting a report of English proficiency test result.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Science: Zoology ====================
  {
    college: 'Science',
    department: 'Zoology',
    program: 'MSc in Zoology',
    discipline: 'Aquatic Biology',
    requirements: `• Applicant must hold a full-time bachelor's degree in zoology, or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Zoology',
    program: 'MSc in Zoology',
    discipline: 'Animal Ecology and Pollution',
    requirements: `• Applicant must hold a full-time bachelor's degree in zoology, or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Zoology',
    program: 'MSc in Zoology',
    discipline: 'Entomology and Parasitology',
    requirements: `• Applicant must hold a full-time bachelor's degree in zoology, or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Zoology',
    program: 'MSc in Zoology',
    discipline: 'Physiology and Biology of Embryology',
    requirements: `• Applicant must hold a full-time bachelor's degree in zoology, or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Zoology',
    program: 'MSc in Zoology',
    discipline: 'Cell Biology, Genetics and Histology',
    requirements: `• Applicant must hold a full-time bachelor's degree in zoology, or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Zoology',
    program: 'MSc in Zoology',
    discipline: 'Zoology',
    requirements: `• Applicant must hold a full-time bachelor's degree in zoology, or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Zoology',
    program: 'PhD in Zoology',
    discipline: 'Zoology',
    requirements: `• Applicant must hold a full-time master's degree in zoology, or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Science: Biochemistry ====================
  {
    college: 'Science',
    department: 'Biochemistry',
    program: 'MSc in Biochemistry',
    discipline: 'Biochemistry',
    requirements: `• Applicant must hold a full-time bachelor's degree in biochemistry or relevant disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA, or equivalent.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Biochemistry',
    program: 'PhD in Biochemistry',
    discipline: 'Biochemistry',
    requirements: `• Applicant must hold a full-time master's degree in biochemistry or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Science: Statistics & Operations Research ====================
  {
    college: 'Science',
    department: 'Statistics & Operations Research',
    program: 'MSc in Statistics',
    discipline: 'Statistics',
    requirements: `• Applicant must hold a full-time bachelor's degree in statistics, operations research, mathematics, computer science, quantitative methods, electrical engineering, industrial engineering or relevant scientific disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent, for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Statistics & Operations Research',
    program: 'PhD in Statistics',
    discipline: 'Statistics',
    requirements: `• Applicant must hold a master's degree in statistics, operations research, mathematics, mathematics-electronics or relevant scientific disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent, for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum success score of 40%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Science: Physics and Astronomy ====================
  {
    college: 'Science',
    department: 'Physics and Astronomy',
    program: 'MSc in Physics',
    discipline: 'Renewable Energy & Environmental Physics',
    requirements: `• Applicant must hold a bachelor's degree in physics or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Physics and Astronomy',
    program: 'MSc in Physics',
    discipline: 'Atomic Spectra and Laser Physics',
    requirements: `• Applicant must hold a bachelor's degree in physics or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Physics and Astronomy',
    program: 'MSc in Physics',
    discipline: 'Condensed Matter Physics',
    requirements: `• Applicant must hold a bachelor's degree in physics or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Physics and Astronomy',
    program: 'MSc in Physics',
    discipline: 'Biomedical Physics',
    requirements: `• Applicant must hold a bachelor's degree in physics or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Physics and Astronomy',
    program: 'MSc in Physics',
    discipline: 'Nuclear Physics',
    requirements: `• Applicant must hold a bachelor's degree in physics or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Physics and Astronomy',
    program: 'MSc in Physics',
    discipline: 'Astronomy',
    requirements: `• Applicant must hold a bachelor's degree in physics or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Physics and Astronomy',
    program: 'MSc in Physics',
    discipline: 'Quantum Technology',
    requirements: `• Applicant must hold a bachelor's degree in physics or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Physics and Astronomy',
    program: 'MSc in Physics',
    discipline: 'Theoretical Physics',
    requirements: `• Applicant must hold a bachelor's degree in physics or relevant scientific and health disciplines from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Physics and Astronomy',
    program: 'PhD in Physics',
    discipline: 'Physics',
    requirements: `• Applicant must hold a full-time master's degree in physics or relevant scientific and health disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Science: Mathematics ====================
  {
    college: 'Science',
    department: 'Mathematics',
    program: 'MSc in Mathematics',
    discipline: 'Mathematics',
    requirements: `• Applicant must hold a full-time bachelor's degree in mathematics, or relevant disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent, provided that applicant's GPA of the specialty courses at the bachelor's stage is at least "Very Good" (3.75/5) or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• A score of at least 400 in the GRE test (Math Subject) or passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Mathematics',
    program: 'PhD in Mathematics',
    discipline: 'Analysis',
    requirements: `• Applicant must hold a full-time bachelor's degree in mathematics from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent, provided that applicant's GPA of the specialty courses at the bachelor's stage is at least "Very Good" (3.75/5) or equivalent.
• Applicant must hold a full-time master's degree in mathematics from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5.5 in the IELTS Academic test or equivalent.
• A score of at least 500 in the GRE test (Math Subject) or passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Science',
    department: 'Mathematics',
    program: 'PhD in Mathematics',
    discipline: 'Geometry & Topology',
    requirements: `• Applicant must hold a full-time bachelor's degree in mathematics from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent, provided that applicant's GPA of the specialty courses at the bachelor's stage is at least "Very Good" (3.75/5) or equivalent.
• Applicant must hold a full-time master's degree in mathematics from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5.5 in the IELTS Academic test or equivalent.
• A score of at least 500 in the GRE test (Math Subject) or passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Science',
    department: 'Mathematics',
    program: 'PhD in Mathematics',
    discipline: 'Applied Mathematics',
    requirements: `• Applicant must hold a full-time bachelor's degree in mathematics from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent, provided that applicant's GPA of the specialty courses at the bachelor's stage is at least "Very Good" (3.75/5) or equivalent.
• Applicant must hold a full-time master's degree in mathematics from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5.5 in the IELTS Academic test or equivalent.
• A score of at least 500 in the GRE test (Math Subject) or passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Science: Geology & Geophysics ====================
  {
    college: 'Science',
    department: 'Geology & Geophysics',
    program: 'MSc in Geology',
    discipline: 'Sedimentary Rocks and Stratigraphy',
    requirements: `• Applicant must hold a full-time bachelor's degree in geology or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Geology & Geophysics',
    program: 'MSc in Geology',
    discipline: 'Economical Geology',
    requirements: `• Applicant must hold a full-time bachelor's degree in geology or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Geology & Geophysics',
    program: 'MSc in Geology',
    discipline: 'Petroleum Geology',
    requirements: `• Applicant must hold a full-time bachelor's degree in geology or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Geology & Geophysics',
    program: 'MSc in Geology',
    discipline: 'Hydrogeology',
    requirements: `• Applicant must hold a full-time bachelor's degree in geology or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Geology & Geophysics',
    program: 'MSc in Geology',
    discipline: 'Paleontology',
    requirements: `• Applicant must hold a full-time bachelor's degree in geology or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Geology & Geophysics',
    program: 'MSc in Geophysics',
    discipline: 'Geophysics',
    requirements: `• Applicant must hold a full-time bachelor's degree in geology or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Geology & Geophysics',
    program: 'PhD in Geosciences',
    discipline: 'Geosciences',
    requirements: `• Applicant must hold a full-time master's degree in geology, geophysics, or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Science: Chemistry ====================
  {
    college: 'Science',
    department: 'Chemistry',
    program: 'MSc in Chemistry',
    discipline: 'Chemistry',
    requirements: `• Applicant must hold a full-time bachelor's degree in chemistry from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Chemistry',
    program: 'MSc in Polymers',
    discipline: 'Polymers',
    requirements: `• Applicant must hold a full-time bachelor's degree in chemistry or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA, or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Science',
    department: 'Chemistry',
    program: 'PhD in Chemistry',
    discipline: 'Inorganic Chemistry',
    requirements: `• Applicant must hold a full-time master's degree in chemistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Science',
    department: 'Chemistry',
    program: 'PhD in Chemistry',
    discipline: 'Physical Chemistry',
    requirements: `• Applicant must hold a full-time master's degree in chemistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Science',
    department: 'Chemistry',
    program: 'PhD in Chemistry',
    discipline: 'Organic Chemistry',
    requirements: `• Applicant must hold a full-time master's degree in chemistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Science',
    department: 'Chemistry',
    program: 'PhD in Chemistry',
    discipline: 'Analytical Chemistry',
    requirements: `• Applicant must hold a full-time master's degree in chemistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

// ... (previous entries up to Science: Chemistry PhD)

  // ==================== Food and Agriculture Sciences: Plant Production ====================
  {
    college: 'Food and Agriculture Sciences',
    department: 'Plant Production',
    program: 'MSc in Horticulture',
    discipline: 'Horticulture',
    requirements: `• Applicant must hold a full-time bachelor's degree in plant production sciences (crops science, horticulture, range science and forestry, or relevant disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Plant Production',
    program: 'MSc in Range Science and Forestry',
    discipline: 'Range Science and Forestry',
    requirements: `• Applicant must hold a full-time bachelor's degree in plant production sciences (crops science, horticulture, range science and forestry, or relevant disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Plant Production',
    program: 'MSc in Crops Science',
    discipline: 'Crops Science',
    requirements: `• Applicant must hold a full-time bachelor's degree in plant production sciences (crops science, horticulture, range science and forestry, or relevant disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Plant Production',
    program: 'PhD in Horticulture',
    discipline: 'Horticulture',
    requirements: `• Applicant must hold a full-time master's degree in plant production sciences (crops science, horticulture, range science and forestry, or relevant Scientific disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude or equivalent.
• Submission a report of an English proficiency test.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Plant Production',
    program: 'PhD in Range Science and Forestry',
    discipline: 'Range Science and Forestry',
    requirements: `• Applicant must hold a full-time master's degree in plant production sciences (crops science, horticulture, range science and forestry, or relevant Scientific disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude or equivalent.
• Submission a report of an English proficiency test.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Plant Production',
    program: 'PhD in Crops Science',
    discipline: 'Crops Science',
    requirements: `• Applicant must hold a full-time master's degree in plant production sciences (crops science, horticulture, range science and forestry, or relevant Scientific disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude or equivalent.
• Submission a report of an English proficiency test.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Food and Agriculture Sciences: Plant Protection ====================
  {
    college: 'Food and Agriculture Sciences',
    department: 'Plant Protection',
    program: 'MSc in Plant Pathology',
    discipline: 'Plant Pathology',
    requirements: `• Applicant must hold a full-time bachelor's degree in plant protection or relevant scientific, health disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Plant Protection',
    program: 'MSc in Pesticides',
    discipline: 'Pesticides',
    requirements: `• Applicant must hold a full-time bachelor's degree in plant protection or relevant scientific, health disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Plant Protection',
    program: 'MSc in Entomology',
    discipline: 'Entomology',
    requirements: `• Applicant must hold a full-time bachelor's degree in plant protection or relevant scientific, health disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Plant Protection',
    program: 'PhD in Plant Pathology',
    discipline: 'Plant Pathology',
    requirements: `• Applicant must hold a full-time master's degree in plant protection or relevant scientific, health disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submitting a report of English proficiency test result.`,
    language: 'Arabic',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Plant Protection',
    program: 'PhD in Entomology',
    discipline: 'Entomology',
    requirements: `• Applicant must hold a full-time master's degree in plant protection or relevant scientific, health disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submitting a report of English proficiency test result.`,
    language: 'Arabic',
    targetGroup: 'Male',
    tuition: 'SAR 120,000',
  },

  // ==================== Food and Agriculture Sciences: Agricultural Economics ====================
  {
    college: 'Food and Agriculture Sciences',
    department: 'Agricultural Economics',
    program: 'MSc in Agricultural Economics',
    discipline: 'Agricultural Economics',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance) in agricultural economics, or relevant scientific disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },

  // ==================== Food and Agriculture Sciences: Soil Sciences ====================
  {
    college: 'Food and Agriculture Sciences',
    department: 'Soil Sciences',
    program: 'MSc in Soil Sciences',
    discipline: 'Soil Sciences',
    requirements: `• Applicant must hold a full-time bachelor's degree in soil sciences or relevant scientific disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Soil Sciences',
    program: 'PhD in Soil Sciences',
    discipline: 'Soil Sciences',
    requirements: `• Applicant must hold a master's degree in soil sciences or relevant scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4.5 in the IELTS- Academic test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Food and Agriculture Sciences: Food and Nutrition Sciences ====================
  {
    college: 'Food and Agriculture Sciences',
    department: 'Food and Nutrition Sciences',
    program: 'MSc in Human Nutrition',
    discipline: 'Human Nutrition',
    requirements: `• Applicant must hold a bachelor's degree in food sciences, human nutrition, or relevant scientific, health disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Food and Nutrition Sciences',
    program: 'MSc in Food Sciences',
    discipline: 'Food Sciences',
    requirements: `• Applicant must hold a bachelor's degree in food sciences, human nutrition, or relevant scientific, health disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Food and Nutrition Sciences',
    program: 'PhD in Human Nutrition',
    discipline: 'Human Nutrition',
    requirements: `• Applicant must hold a full-time master's degree in food sciences, human nutrition, or relevant scientific, health disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Food and Nutrition Sciences',
    program: 'PhD in Food Sciences',
    discipline: 'Food Sciences',
    requirements: `• Applicant must hold a full-time master's degree in food sciences, human nutrition, or relevant scientific, health disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Food and Agriculture Sciences: Agricultural Extension and Rural Society ====================
  {
    college: 'Food and Agriculture Sciences',
    department: 'Agricultural Extension and Rural Society',
    program: 'MSc in Agricultural Extension',
    discipline: 'Agricultural Extension',
    requirements: `• Applicant must hold a full-time bachelor's degree in agricultural extension and rural society or relevant scientific, humanities, disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Agricultural Extension and Rural Society',
    program: 'PhD in Agricultural Extension',
    discipline: 'Agricultural Extension',
    requirements: `• Applicant must hold a full-time master's degree in agricultural extension and rural society relevant scientific, humanities, disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submission a report of an English proficiency test.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Food and Agriculture Sciences: Agricultural Engineering ====================
  {
    college: 'Food and Agriculture Sciences',
    department: 'Agricultural Engineering',
    program: 'MSc in Agricultural Engineering',
    discipline: 'Engineering of Machinery and Farm Power',
    requirements: `• Applicant must hold a full-time bachelor's degree in agricultural engineering or relevant engineering disciplines from King Saud University or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Agricultural Engineering',
    program: 'MSc in Agricultural Engineering',
    discipline: 'Engineering of Environment and Agricultural Buildings',
    requirements: `• Applicant must hold a full-time bachelor's degree in agricultural engineering or relevant engineering disciplines from King Saud University or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Agricultural Engineering',
    program: 'MSc in Agricultural Engineering',
    discipline: 'Engineering of Food Processing',
    requirements: `• Applicant must hold a full-time bachelor's degree in agricultural engineering or relevant engineering disciplines from King Saud University or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Agricultural Engineering',
    program: 'MSc in Agricultural Engineering',
    discipline: 'Engineering of Water and Irrigation Systems',
    requirements: `• Applicant must hold a full-time bachelor's degree in agricultural engineering or relevant engineering disciplines from King Saud University or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Agricultural Engineering',
    program: 'PhD in Agricultural Engineering',
    discipline: 'Engineering of Machinery and Farm Power',
    requirements: `• Applicant must hold a full-time master's degree in agricultural engineering or relevant engineering disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submission a report of an English proficiency test.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Agricultural Engineering',
    program: 'PhD in Agricultural Engineering',
    discipline: 'Engineering of Environment and Agricultural Buildings',
    requirements: `• Applicant must hold a full-time master's degree in agricultural engineering or relevant engineering disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submission a report of an English proficiency test.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Agricultural Engineering',
    program: 'PhD in Agricultural Engineering',
    discipline: 'Engineering of Food Processing',
    requirements: `• Applicant must hold a full-time master's degree in agricultural engineering or relevant engineering disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submission a report of an English proficiency test.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Agricultural Engineering',
    program: 'PhD in Agricultural Engineering',
    discipline: 'Engineering of Water and Irrigation Systems',
    requirements: `• Applicant must hold a full-time master's degree in agricultural engineering or relevant engineering disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submission a report of an English proficiency test.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Food and Agriculture Sciences: Animal Production ====================
  {
    college: 'Food and Agriculture Sciences',
    department: 'Animal Production',
    program: 'MSc in Farm Animals',
    discipline: 'Farm Animals',
    requirements: `• Applicant must hold a full-time bachelor's degree in animal production, Veterinary Medicine, zoology, food and nutrition sciences, or relevant scientific disciplines, from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Animal Production',
    program: 'MSc in Poultry',
    discipline: 'Poultry Production',
    requirements: `• Applicant must hold a full-time bachelor's degree in animal production, Veterinary Medicine, zoology, food and nutrition sciences, or relevant scientific disciplines, from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Food and Agriculture Sciences',
    department: 'Animal Production',
    program: 'PhD in Animal Production and Poultry Production',
    discipline: 'Animal and Poultry Production',
    requirements: `• Applicant must hold a full-time master's degree in animal production, Veterinary Medicine, zoology, or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4 in the IELTS-Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

// ... (previous entries up to Food and Agriculture Sciences: Animal Production PhD)

  // ==================== Computer and Information Sciences: Computer Science ====================
  {
    college: 'Computer and Information Sciences',
    department: 'Computer Science',
    program: 'MSc in Computer Science',
    discipline: 'Computer Science',
    requirements: `• Applicant must hold a full-time bachelor's degree in computer science, IT, information systems, software engineering, computer engineering, non-educational computer disciplines, engineering, mathematics, or statistics and operations research, from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 4 in the IELTS-Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.
• A score of at least 70 in the Quantitative section of the General Aptitude Test or 140 in the Quantitative section of the GRE-General test.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Computer and Information Sciences',
    department: 'Computer Science',
    program: 'MSc in Artificial Intelligence',
    discipline: 'Artificial Intelligence',
    requirements: `• Applicant must hold a full-time bachelor's degree in computer science, IT, information systems, software engineering, computer engineering, non-educational computer disciplines, engineering, mathematics, or statistics and operations research, from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 4 in the IELTS-Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.
• A score of at least 70 in the Quantitative section of the General Aptitude Test or 140 in the Quantitative section of the GRE-General test.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Computer and Information Sciences',
    department: 'Computer Science',
    program: 'PhD in Computer Science',
    discipline: 'Computer Science',
    requirements: `• Applicant must hold a full-time master's degree in computer science, software engineering, IT, computer engineering, information systems, or non-educational computer disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.
• A score of at least 75 in the Quantitative section of the General Aptitude Test or 144 in the Quantitative section of the GRE-General test.
• A score of at least 5.5 in the IELTS-Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Computer and Information Sciences: Computer Engineering ====================
  {
    college: 'Computer and Information Sciences',
    department: 'Computer Engineering',
    program: 'MSc in Computer Engineering',
    discipline: 'Computer Engineering',
    requirements: `• Applicant must hold a full-time bachelor's degree in computer engineering, computer sciences, electrical engineering, software engineering, IT, or relevant scientific disciplines, from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Submitting a report of English proficiency test result.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Computer and Information Sciences',
    department: 'Computer Engineering',
    program: 'PhD in Computer Engineering',
    discipline: 'Computer Engineering',
    requirements: `• Applicant must hold a full-time master's degree in computer engineering, computer sciences, electrical engineering, software engineering, IT, or relevant scientific disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Submitting a report of English proficiency test result.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Computer and Information Sciences: Information Systems ====================
  {
    college: 'Computer and Information Sciences',
    department: 'Information Systems',
    program: 'MSc in Information Systems',
    discipline: 'Information Systems',
    requirements: `• Applicant must hold a full-time bachelor's degree in information systems, software engineering, computer sciences, computer engineering, IT, disciplines from the following colleges: (Engineering, Architecture and Planning, Science, Business Administration), or educational computer, from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submitting a report of English proficiency test result.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Computer and Information Sciences',
    department: 'Information Systems',
    program: 'PhD in Information Systems',
    discipline: 'Information Systems',
    requirements: `• Applicant must hold a full-time master's degree in information systems or computer-related disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5.5 in the IELTS-Academic test or equivalent.
• A score of at least 80 in the Quantitative section of the General Aptitude Test or 148 in the Quantitative section of the GRE-General test.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Computer and Information Sciences: Software Engineering ====================
  {
    college: 'Computer and Information Sciences',
    department: 'Software Engineering',
    program: 'MSc in Software Engineering',
    discipline: 'Software Engineering',
    requirements: `• Applicant must hold a full-time bachelor's degree in software engineering, computer sciences, computer engineering, information systems, IT, disciplines from the following colleges: (Engineering, Architecture and Planning, Science, Business Administration), or educational computer, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 70 in the General Aptitude Test (Quantitative Section) or at least 144 in the GRE-General test (Quantitative section).
• A score of at least 4.5 in the IELTS- Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Computer and Information Sciences',
    department: 'Software Engineering',
    program: 'PhD in Software Engineering',
    discipline: 'Software Engineering',
    requirements: `• Applicant must hold a full-time master's degree in software engineering, computer science, information technology, computer engineering, or information systems, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 80 in the Quantitative section of the General Aptitude Test or 148 in the Quantitative section of the GRE-General test.
• A score of at least 5.5 in the IELTS-Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Computer and Information Sciences: Information Technology ====================
  {
    college: 'Computer and Information Sciences',
    department: 'Information Technology',
    program: 'MSc in Information Technology',
    discipline: 'Information Technology',
    requirements: `• Applicant must hold a full-time bachelor's degree in information technology, information systems, computer science, software engineering, or computer engineering, or relevant disciplines, from King Saud University or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 70 in the Quantitative section of the General Aptitude Test or 144 in the Quantitative section of the GRE-General test.
• A score of at least 4 in the IELTS-Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },

  // ==================== Computer and Information Sciences: Cyber Security ====================
  {
    college: 'Computer and Information Sciences',
    department: 'Council of Joint Master\'s Program in Cyber Security',
    program: 'MSc in Cyber Security',
    discipline: 'Cyber Security',
    requirements: `• Applicant must a full-time bachelor's degree in any scientific, health, humanities, or relevant disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4 in the IELTS-Academic test or equivalent.
• A score of at least 65 in the General Aptitude Test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },

  // ==================== Business Administration: Public Administration ====================
  {
    college: 'Business Administration',
    department: 'Public Administration',
    program: 'MSc in Public Administration',
    discipline: 'Human Resources Management',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in public administration, or relevant disciplines from KSU or any accredited university, with at least a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Business Administration',
    department: 'Public Administration',
    program: 'MSc in Public Administration',
    discipline: 'Non-Profit Organizations',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in public administration, or relevant disciplines from KSU or any accredited university, with at least a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Business Administration',
    department: 'Public Administration',
    program: 'MSc in Public Administration',
    discipline: 'Local Administration',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in public administration, or relevant disciplines from KSU or any accredited university, with at least a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Business Administration',
    department: 'Public Administration',
    program: 'MSc in Public Administration',
    discipline: 'Budget & Public Policies',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in public administration, or relevant disciplines from KSU or any accredited university, with at least a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Business Administration',
    department: 'Public Administration',
    program: 'MSc in Public Administration',
    discipline: 'Leadership & Strategic Management',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in public administration, or relevant disciplines from KSU or any accredited university, with at least a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Business Administration',
    department: 'Public Administration',
    program: 'PhD in Public Administration',
    discipline: 'Human Resource Management in Public Sector',
    requirements: `• Applicant must hold a full-time master's degree in public administration, or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 6 in the IELTS Academic test or equivalent in the TOEFL-IBT test or the TOEFL-PBT test.
• A minimum of two years' work experience.
• A score of at least 80 in the General Aptitude test or equivalent.`,
    language: 'Arabic- English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },
  {
    college: 'Business Administration',
    department: 'Public Administration',
    program: 'PhD in Public Administration',
    discipline: 'Public Finance Administration',
    requirements: `• Applicant must hold a full-time master's degree in public administration, or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 6 in the IELTS Academic test or equivalent in the TOEFL-IBT test or the TOEFL-PBT test.
• A minimum of two years' work experience.
• A score of at least 80 in the General Aptitude test or equivalent.`,
    language: 'Arabic- English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Business Administration: Finance ====================
  {
    college: 'Business Administration',
    department: 'Finance Administration',
    program: 'MSc in Finance',
    discipline: 'Finance',
    requirements: `• Applicant must hold a full-time bachelor's degree in business administration, or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5.5 in the IELTS Academic test or equivalent.
• A score of at least 75 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },

  // ==================== Business Administration: Health Administration ====================
  {
    college: 'Business Administration',
    department: 'Health Administration',
    program: 'MSc in Health Administration',
    discipline: 'Health Insurance',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree in relevant health, scientific disciplines, and from the humanities disciplines (psychology, social service, English language, literature and translation) from KSU or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.
• A score of at least 70 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Business Administration',
    department: 'Health Administration',
    program: 'MSc in Health Administration',
    discipline: 'Healthcare Quality',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree in relevant health, scientific disciplines, and from the humanities disciplines (psychology, social service, English language, literature and translation) from KSU or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.
• A score of at least 70 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Business Administration',
    department: 'Health Administration',
    program: 'MSc in Health Administration',
    discipline: 'Health Policies',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree in relevant health, scientific disciplines, and from the humanities disciplines (psychology, social service, English language, literature and translation) from KSU or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.
• A score of at least 70 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Business Administration',
    department: 'Health Administration',
    program: 'PhD in Healthcare Management and Policies',
    discipline: 'Healthcare Management and Policies',
    requirements: `• Applicant must hold a master's degree in health administration, administrative, or health disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) CGPA or equivalent. For related disciplines, the applicant must consult the concerned department before applying through the electronic portal.
• A score of at least 6 in the IELTS Academic test or equivalent.
• Passing a written examination, held by the department, with a minimum score of 50%.
• Applicant must submit a Statement of Purpose.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Business Administration: Accounting ====================
  {
    college: 'Business Administration',
    department: 'Accounting',
    program: 'MSc in Accounting',
    discipline: 'Accounting',
    requirements: `• Applicant must hold a full-time bachelor's degree in accounting from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 5.5 in the IELTS Academic test or equivalent.
• A score of at least 70 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },

  // ==================== Business Administration: Economics ====================
  {
    college: 'Business Administration',
    department: 'Economics',
    program: 'MSc in Economics',
    discipline: 'Economics',
    requirements: `• Applicant must hold a full-time bachelor's degree in economics, or relevant disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4 in the IELTS Academic test or equivalent.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Business Administration',
    department: 'Economics',
    program: 'PhD in Economics',
    discipline: 'Economics',
    requirements: `• Applicant must hold a full-time master's degree in economics or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5.5 in the IELTS Academic test or equivalent.
• Submitting the report of the GRE result.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Business Administration: MBA ====================
  {
    college: 'Business Administration',
    department: 'Council of Graduate Programs in Business Administration',
    program: 'MSc in Business Administration',
    discipline: 'Business Administration',
    requirements: `• Applicant must hold a full-time bachelor's degree in business administration or relevant scientific, humanities, or health disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 6 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.
• Applicant must submit the report of the GMAT test result.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Business Administration',
    department: 'Council of Graduate Programs in Business Administration',
    program: 'PhD in Business Administration',
    discipline: 'Management Information Systems',
    requirements: `• Applicant must hold a full-time master's degree in business administration, management information systems, the engineering and computer disciplines of the management information systems track, or relevant disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 6 in the IELTS Academic test or equivalent.
• Applicant must submit the report of the GMAT test result.
• A minimum of three years' work experience.
• A score of at least 70 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 120,000',
  },

  // ==================== Business Administration: Human Resources ====================
  {
    college: 'Business Administration',
    department: 'Administration',
    program: 'MSc in Human Resources',
    discipline: 'Human Resources Management',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in any discipline from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },

  // ==================== Business Administration: Quantitative Analysis ====================
  {
    college: 'Business Administration',
    department: 'Quantitative Analysis',
    program: 'MSc in Decision Sciences',
    discipline: 'Decision Sciences',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in business administration, or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• A score of at least 70 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },

  // ==================== Business Administration: Management Information Systems ====================
  {
    college: 'Business Administration',
    department: 'Management Information Systems',
    program: 'MSc in E-Business',
    discipline: 'E-Business',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in business administration or relevant scientific, health disciplines from KSU or any accredited university with a minimum of an "Good" (2.75/5) the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },

// ... (previous entries up to Business Administration: MIS)

  // ==================== Pharmacy: Pharmacognosy ====================
  {
    college: 'Pharmacy',
    department: 'Pharmacognosy',
    program: 'MSc in Pharmacy (Pharmacognos)',
    discipline: 'Pharmacognosy',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmacy, pharmaceutical sciences, a Pharm. D., from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Pharmacy',
    department: 'Pharmacognosy',
    program: 'PhD in Pharmacy (Pharmacognos)',
    discipline: 'Pharmacognosy',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmacy, pharmaceutical sciences, a Pharm. D., from KSU or any accredited university.
• Applicant must hold a full-time Master's degree in pharmacy, pharmaceutical sciences or relevant health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },

  // ==================== Pharmacy: Pharmaceutical Chemistry ====================
  {
    college: 'Pharmacy',
    department: 'Pharmaceutical Chemistry',
    program: 'MSc in Pharmaceutical Chemistry',
    discipline: 'Medicinal Chemistry',
    requirements: `• Applicant must hold a bachelor's degree in pharmacy, pharmaceutical sciences, a Pharm. D. from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent, student's GPA of the specialty courses at the bachelor's stage is at least "Very Good" (3.75 / 5) or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Pharmacy',
    department: 'Pharmaceutical Chemistry',
    program: 'MSc in Pharmaceutical Chemistry',
    discipline: 'Analytical Pharmaceutical Chemistry',
    requirements: `• Applicant must hold a bachelor's degree in pharmacy, pharmaceutical sciences, a Pharm. D. from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent, student's GPA of the specialty courses at the bachelor's stage is at least "Very Good" (3.75 / 5) or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Pharmacy',
    department: 'Pharmaceutical Chemistry',
    program: 'PhD in Pharmaceutical Chemistry',
    discipline: 'Medicinal Chemistry',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmaceutical sciences or a Pharm. D. from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent, student's GPA of the specialty courses at the bachelor's stage is at least "Very Good" (3.75 / 5) or equivalent.
• Applicant must hold a Master's degree in pharmacy, pharmaceutical or relevant health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },
  {
    college: 'Pharmacy',
    department: 'Pharmaceutical Chemistry',
    program: 'PhD in Pharmaceutical Chemistry',
    discipline: 'Analytical Pharmaceutical Chemistry',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmaceutical sciences or a Pharm. D. from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent, student's GPA of the specialty courses at the bachelor's stage is at least "Very Good" (3.75 / 5) or equivalent.
• Applicant must hold a Master's degree in pharmacy, pharmaceutical or relevant health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },

  // ==================== Pharmacy: Pharmacology and Toxicology ====================
  {
    college: 'Pharmacy',
    department: 'Pharmacology and Toxicology',
    program: 'MSc in Pharmacy (Pharmacology)',
    discipline: 'Pharmacology',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmacy, pharmaceutical sciences or a Pharm. D. from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent.; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Pharmacy',
    department: 'Pharmacology and Toxicology',
    program: 'MSc in Pharmacy (Toxicology)',
    discipline: 'Toxicology',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmacy, pharmaceutical sciences or a Pharm. D. from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent.; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Pharmacy',
    department: 'Pharmacology and Toxicology',
    program: 'PhD in Pharmacology and Toxicology',
    discipline: 'Pharmacology',
    requirements: `• Applicant must hold a bachelor's degree in pharmacy, pharmaceutical sciences, a Pharm. D., from KSU or any accredited university.
• Applicant must hold a full-time master's degree in pharmacy, pharmaceutical sciences, or relevant health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },
  {
    college: 'Pharmacy',
    department: 'Pharmacology and Toxicology',
    program: 'PhD in Pharmacology and Toxicology',
    discipline: 'Toxicology',
    requirements: `• Applicant must hold a bachelor's degree in pharmacy, pharmaceutical sciences, a Pharm. D., from KSU or any accredited university.
• Applicant must hold a full-time master's degree in pharmacy, pharmaceutical sciences, or relevant health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },

  // ==================== Pharmacy: Pharmaceutics ====================
  {
    college: 'Pharmacy',
    department: 'Pharmaceutics',
    program: 'MSc in Pharmaceutics',
    discipline: 'Pharmaceutics',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmaceutical sciences, a Pharm. D. from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 65 in the General Aptitude test or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Pharmacy',
    department: 'Pharmaceutics',
    program: 'PhD in Pharmaceutics',
    discipline: 'Pharmaceutics',
    requirements: `• Applicant must hold a bachelor's degree in pharmaceutical sciences or a Pharm. D. from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent, student's GPA of the specialty courses at the bachelor's stage is at least "Very Good" (3.75 / 5) or equivalent.
• Applicant must hold a full-time master's degree in pharmacy, pharmaceutical sciences, or relevant health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 65 in the General Aptitude test or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },

  // ==================== Pharmacy: Clinical Pharmacy ====================
  {
    college: 'Pharmacy',
    department: 'Clinical Pharmacy',
    program: 'MSc in Pharmacy (Clinical Pharmacy)',
    discipline: 'Clinical Pharmacy',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmaceutical sciences or a Pharm. D. from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 65 in the General Aptitude or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Pharmacy',
    department: 'Clinical Pharmacy',
    program: 'MSc in Pharmaceutical Outcomes and Policy',
    discipline: 'Pharmaceutical Outcomes and Policy',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmaceutical sciences or a Pharm. D. from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 65 in the General Aptitude or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Pharmacy',
    department: 'Clinical Pharmacy',
    program: 'PhD in Pharmacy Practice',
    discipline: 'Pharmaceutical services, outcomes and policies.',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmaceutical sciences or a Pharm. D. from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) or equivalent.
• Applicant must hold a master's degree in pharmacy, pharmaceutical sciences, public health, health economics, health outcomes, or health administration. from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 65 in the General Aptitude test or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },
  {
    college: 'Pharmacy',
    department: 'Clinical Pharmacy',
    program: 'PhD in Pharmacy Practice',
    discipline: 'Precision pharmacotherapy',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmaceutical sciences or a Pharm. D. from KSU or any accredited university, with a minimum of a "Very Good" (3.75 / 5) or equivalent.
• Applicant must hold a master's degree in pharmacy, pharmaceutical sciences, public health, health economics, health outcomes, or health administration. from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 65 in the General Aptitude test or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },

  // ==================== Pharmacy: Quality Control in Pharmacy ====================
  {
    college: 'Pharmacy',
    department: 'Council of Joint Master\'s Program in Quality Control in Pharmacy',
    program: 'MSc in Quality Control in Pharmacy',
    discipline: 'Quality Control in Pharmacy',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmaceutical sciences or a Pharm. D. from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• Submission a report of an English proficiency test.
• Passing a written examination, with a minimum score of 40% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Medicine: Anatomy ====================
  {
    college: 'Medicine',
    department: 'Anatomy',
    program: 'MSc in Anatomy',
    discipline: 'Anatomy',
    requirements: `• Applicant must hold a full-time bachelor's degree in medicine and surgery or any relevant health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant health disciplines, applicant must refer to the concerned department before starting the application process.
• Submitting a report of English proficiency test result.
• A minimum of 1-year experience in the field of specialization.
• Passing a written examination, with a minimum score of 50% held by the department.
• Passing a practical examination, with a minimum score of 60% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Medicine',
    department: 'Anatomy',
    program: 'PhD in Anatomy',
    discipline: 'Anatomy',
    requirements: `• Applicant must hold a full-time master's degree in anatomy or any relevant health disciplines from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Submitting a report of English proficiency test result.
• A minimum of 2 years' experience in the field of specialization.
• Passing a written examination, with a minimum score of 50% held by the department.
• Passing a practical examination, with a minimum score of 70% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },

  // ==================== Medicine: Physiology ====================
  {
    college: 'Medicine',
    department: 'Physiology',
    program: 'MSc in Physiology',
    discipline: 'Physiology',
    requirements: `• Applicant must hold a full-time bachelor's degree in medicine and surgery from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent, provided that the GPA of the specialty courses at the bachelor's stage is at least "Very Good" (3.75 / 5) GPA or equivalent.
• Relevant health disciplines may be accepted, provided that the applicant holds a bachelor's degree from KSU or any accredited university and that applicant's GPA is at least "Very Good" (3.75/5) GPA or equivalent; for relevant health disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS- Academic test or equivalent.
• A score of at least 65 in the General Aptitude Test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Medicine',
    department: 'Physiology',
    program: 'PhD in Physiology',
    discipline: 'Physiology',
    requirements: `• Applicant must hold a full-time bachelor's degree in medicine and surgery or other health disciplines from KSU or any accredited university.; for relevant health disciplines, applicant must refer to the concerned department before starting the application process.
• Applicant must hold a full-time master's degree in physiology from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 6 in the IELTS- Academic test or equivalent.
• A score of at least 65 in the General Aptitude Test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },

  // ==================== Medicine: Medical Education ====================
  {
    college: 'Medicine',
    department: 'Medical Education',
    program: 'MSc in Medical Education',
    discipline: 'Medical Education',
    requirements: `• Applicant must hold a full-time bachelor's degree in medicine and surgery or any relevant health disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant health disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Medicine: Clinical Research ====================
  {
    college: 'Medicine',
    department: 'Council of Joint Master\'s Program in Clinical Research',
    program: 'MSc in Clinical Research',
    discipline: 'Clinical Research',
    requirements: `• Applicant must hold a full-time bachelor's degree in medicine and surgery or any relevant health disciplines from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant health disciplines, applicant must refer to the concerned department before starting the application process.
• The qualification classification is considered by the Saudi Commission for Health Specialties if the program entry is a Bachelor's degree in medicine and surgery only.
• A score of at least 6 in the IELTS Academic test or equivalent.
• Completion of the internship.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
// ... (previous entries up to Medicine: Clinical Research)

  // ==================== Dentistry ====================
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'MSc in Dentistry',
    discipline: 'Restorative Dentistry',
    requirements: `• Applicant must hold a full-time bachelor's degree in dentistry from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.
• Applicants for Restorative Dentistry, Prosthodontics, and Orthodontics tracks must pass a practical exam, and its grade will be part of the written examination score.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 260,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'MSc in Dentistry',
    discipline: 'Endodontics',
    requirements: `• Applicant must hold a full-time bachelor's degree in dentistry from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 260,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'MSc in Dentistry',
    discipline: 'Prosthodontics',
    requirements: `• Applicant must hold a full-time bachelor's degree in dentistry from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.
• Applicants for Restorative Dentistry, Prosthodontics, and Orthodontics tracks must pass a practical exam, and its grade will be part of the written examination score.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 260,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'MSc in Dentistry',
    discipline: 'Periodontics',
    requirements: `• Applicant must hold a full-time bachelor's degree in dentistry from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 260,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'MSc in Dentistry',
    discipline: 'Pediatric Dentistry',
    requirements: `• Applicant must hold a full-time bachelor's degree in dentistry from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 260,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'MSc in Dentistry',
    discipline: 'Orthodontics',
    requirements: `• Applicant must hold a full-time bachelor's degree in dentistry from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.
• Applicants for Restorative Dentistry, Prosthodontics, and Orthodontics tracks must pass a practical exam, and its grade will be part of the written examination score.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 260,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'MSc in Dentistry',
    discipline: 'Dental Public Health',
    requirements: `• Applicant must hold a full-time bachelor's degree in dentistry from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 260,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'DSc in Dentistry',
    discipline: 'Restorative Dentistry',
    requirements: `• Applicant must hold a full-time bachelor's degree or master's degree in dentistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.
• Applicants for Restorative Dentistry, Prosthodontics, and Orthodontics tracks must pass a practical exam, and its grade will be part of the written examination score.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 350,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'DSc in Dentistry',
    discipline: 'Endodontics',
    requirements: `• Applicant must hold a full-time bachelor's degree or master's degree in dentistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 350,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'DSc in Dentistry',
    discipline: 'Prosthodontics',
    requirements: `• Applicant must hold a full-time bachelor's degree or master's degree in dentistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.
• Applicants for Restorative Dentistry, Prosthodontics, and Orthodontics tracks must pass a practical exam, and its grade will be part of the written examination score.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 350,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'DSc in Dentistry',
    discipline: 'Periodontics',
    requirements: `• Applicant must hold a full-time bachelor's degree or master's degree in dentistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 350,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'DSc in Dentistry',
    discipline: 'Pediatric Dentistry',
    requirements: `• Applicant must hold a full-time bachelor's degree or master's degree in dentistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 350,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'DSc in Dentistry',
    discipline: 'Orthodontics',
    requirements: `• Applicant must hold a full-time bachelor's degree or master's degree in dentistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.
• Applicants for Restorative Dentistry, Prosthodontics, and Orthodontics tracks must pass a practical exam, and its grade will be part of the written examination score.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 350,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'DSc in Dentistry',
    discipline: 'Oral and Maxillofacial Surgery',
    requirements: `• Applicant must hold a full-time bachelor's degree or master's degree in dentistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 350,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'DSc in Dentistry',
    discipline: 'Oral Dentistry',
    requirements: `• Applicant must hold a full-time bachelor's degree or master's degree in dentistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 350,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'DSc in Dentistry',
    discipline: 'Dental Public Health',
    requirements: `• Applicant must hold a full-time bachelor's degree or master's degree in dentistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 350,000',
  },
  {
    college: 'Dentistry',
    department: 'Council of Joint Graduate Programs in Dentistry',
    program: 'DSc in Dentistry',
    discipline: 'Oral and Maxillofacial Radiology',
    requirements: `• Applicant must hold a full-time bachelor's degree or master's degree in dentistry from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A score of at least 6.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 350,000',
  },

  // ==================== Nursing ====================
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Nursing Administration',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Internal Surgical Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Childhood Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Psychiatric and Mental Health',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Community Health Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Primary care Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Maternal Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Midwifery Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'PhD in Nursing',
    discipline: 'Nursing',
    requirements: `• Applicant must hold a full-time master's degree in nursing from KSU or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• A minimum of 2 years' experience.
• passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },

  // ==================== Applied Medical Sciences ====================
  {
    college: 'Applied Medical Sciences',
    department: 'Community Health Sciences',
    program: 'MSc in Clinical Nutrition',
    discipline: 'Clinical Nutrition',
    requirements: `• Applicant must hold a full-bachelor's degree in clinical nutrition or relevant disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Community Health Sciences',
    program: 'PhD in Community Health Sciences: Clinical Nutrition',
    discipline: 'Clinical Nutrition',
    requirements: `• Applicant must hold a full-time master's degree in clinical nutrition or relevant disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 5.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Clinical Laboratory Sciences',
    program: 'MSc in Clinical Laboratory Sciences',
    discipline: 'Medical Microbiology',
    requirements: `• Applicant must hold a full-time bachelor's degree in clinical laboratory sciences or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization., for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Clinical Laboratory Sciences',
    program: 'MSc in Clinical Laboratory Sciences',
    discipline: 'Medical Biochemistry',
    requirements: `• Applicant must hold a full-time bachelor's degree in clinical laboratory sciences or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization., for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Clinical Laboratory Sciences',
    program: 'MSc in Clinical Laboratory Sciences',
    discipline: 'Hematology and Serology',
    requirements: `• Applicant must hold a full-time bachelor's degree in clinical laboratory sciences or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization., for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Clinical Laboratory Sciences',
    program: 'PhD in Clinical Laboratory Sciences',
    discipline: 'Medical Microbiology',
    requirements: `• Applicant must hold a full-time master's degree in clinical laboratory sciences or relevant medical disciplines (such as clinical biochemistry, medical microbiology, hematology, Clinical Immunology and blood transfusion, medical genetics, and clinical pathology) from King Saud University or any accredited university, with a minimum of "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• Passing a written examination, with a minimum success score of 50% held by the department.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Clinical Laboratory Sciences',
    program: 'PhD in Clinical Laboratory Sciences',
    discipline: 'Clinical Biochemistry',
    requirements: `• Applicant must hold a full-time master's degree in clinical laboratory sciences or relevant medical disciplines (such as clinical biochemistry, medical microbiology, hematology, Clinical Immunology and blood transfusion, medical genetics, and clinical pathology) from King Saud University or any accredited university, with a minimum of "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• Passing a written examination, with a minimum success score of 50% held by the department.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Clinical Laboratory Sciences',
    program: 'PhD in Clinical Laboratory Sciences',
    discipline: 'Medical Genetics',
    requirements: `• Applicant must hold a full-time master's degree in clinical laboratory sciences or relevant medical disciplines (such as clinical biochemistry, medical microbiology, hematology, Clinical Immunology and blood transfusion, medical genetics, and clinical pathology) from King Saud University or any accredited university, with a minimum of "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• Passing a written examination, with a minimum success score of 50% held by the department.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Clinical Laboratory Sciences',
    program: 'PhD in Clinical Laboratory Sciences',
    discipline: 'Hematology & Blood Transfusion',
    requirements: `• Applicant must hold a full-time master's degree in clinical laboratory sciences or relevant medical disciplines (such as clinical biochemistry, medical microbiology, hematology, Clinical Immunology and blood transfusion, medical genetics, and clinical pathology) from King Saud University or any accredited university, with a minimum of "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• Passing a written examination, with a minimum success score of 50% held by the department.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Clinical Laboratory Sciences',
    program: 'PhD in Clinical Laboratory Sciences',
    discipline: 'Clinical Immunology',
    requirements: `• Applicant must hold a full-time master's degree in clinical laboratory sciences or relevant medical disciplines (such as clinical biochemistry, medical microbiology, hematology, Clinical Immunology and blood transfusion, medical genetics, and clinical pathology) from King Saud University or any accredited university, with a minimum of "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• Passing a written examination, with a minimum success score of 50% held by the department.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Health Rehabilitation Sciences',
    program: 'MSc in Physiotherapy',
    discipline: 'Physiotherapy',
    requirements: `• Applicant must hold a full-time bachelor's degree in physiotherapy from King Saud University or any accredited university, with a minimum of "Good" (2.75/5) GPA or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Health Rehabilitation Sciences',
    program: 'PhD in Rehabilitation Sciences',
    discipline: 'Rehabilitation Sciences',
    requirements: `• Applicant must have a bachelor's degree in physiotherapy, speech-language pathology, audiology, occupational therapy, or respiratory therapy from King Saud University or any accredited university.
• Applicant must hold a full-time master's degree in physiotherapy, speech-language pathology, audiology, occupational therapy, respiratory therapy, or a related health discipline from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) CGPA or equivalent. For related disciplines, the applicant must contact the concerned department to confirm his eligibility before applying via the Electronic Admission Portal".
• Please upload copies of your published research papers (for the initial screening and evaluation).
• A score of at least 65 in the General Aptitude test or equivalent.
• A score of at least 5.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Optometry',
    program: 'MSc in Optometry',
    discipline: 'Optometry',
    requirements: `• Applicant must hold a full-time bachelor's degree in optometry and vision science from King Saud University or any university accredited by Ministry of Education with a minimum of an "Good" (2.75/5) GPA or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Optometry',
    program: 'PhD in Optometry and Vision Sciences',
    discipline: 'Optometry and Vision Sciences',
    requirements: `• Applicant must hold a full-time master's degree in optometry from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) CGPA or equivalent.
• A score of at least 6 in the IELTS Academic test or equivalent.
• Passing a written examination, held by the department, with a minimum score of 50%.
• Applicant must submit a research proposal demonstrating his/her research interests.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 150,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Radiological Sciences',
    program: 'MSc in Radiological Sciences',
    discipline: 'Radiation Protection',
    requirements: `• Applicant must hold a full-time bachelor's degree in radiological sciences, diagnostic imaging technique, or x-ray and medical imaging, medical physics, or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent.
• Applicant with medical physics degree can apply only for Radiation Protection.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Completion of the internship, or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Radiological Sciences',
    program: 'MSc in Radiological Sciences',
    discipline: 'Nuclear Medicine and Molecular Imaging',
    requirements: `• Applicant must hold a full-time bachelor's degree in radiological sciences, diagnostic imaging technique, or x-ray and medical imaging, medical physics, or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Completion of the internship, or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Radiological Sciences',
    program: 'MSc in Radiological Sciences',
    discipline: 'Medical Ultrasound Waves',
    requirements: `• Applicant must hold a full-time bachelor's degree in radiological sciences, diagnostic imaging technique, or x-ray and medical imaging, medical physics, or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Completion of the internship, or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Radiological Sciences',
    program: 'MSc in Radiological Sciences',
    discipline: 'MRI Techniques',
    requirements: `• Applicant must hold a full-time bachelor's degree in radiological sciences, diagnostic imaging technique, or x-ray and medical imaging, medical physics, or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Completion of the internship, or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Biomedical Engineering Technology',
    program: 'MSc in Biomedical Engineering',
    discipline: 'Biomedical Engineering',
    requirements: `• Applicant must hold a full-time bachelor's degree in biomedical technology, biomedical engineering or relevant engineering or health disciplines from King Saud University or any accredited university, with a minimum of an "Very Good" (3.75/5) GPA or equivalent., For relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal. The classification of program graduates by the Saudi Commission for Health Specialties is restricted to those accepted into the program holding a bachelor's degree in biomedical technology or biomedical engineering.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Dental health',
    program: 'MSc in Dental Technology',
    discipline: 'Dental technology',
    requirements: `• Applicant must hold a full-time bachelor's degree in dental technology or a related discipline from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) CGPA or equivalent. For related disciplines, the applicant must consult the concerned department before applying through the electronic portal.
• The qualification classification is considered by the Saudi Commission for Health Specialties if the program entry is a Bachelor's degree in Dental Technology only.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Dental health',
    program: 'MSC in Dental Hygiene',
    discipline: 'Dental Hygiene',
    requirements: `• Applicant must hold a full-time bachelor's degree in dental health from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) CGPA or equivalent.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },

  // ==================== Deanship of Graduate Studies - Interdisciplinary and Joint Programs ====================
  {
    college: 'Deanship of Graduate Studies',
    department: 'Council of Joint Master\'s Program in Comparative Literary and Cultural Studies',
    program: 'Master of Arts in Comparative Literary and Cultural Studies',
    discipline: 'Comparative Literary and Cultural Studies',
    requirements: `• Applicant must hold a full-time bachelor's degree in the following disciplines: Arabic or English literature, comparative literature, translation, media, history, anthropology, fine arts, linguistics, political science, cultural studies, theology, psychology, sociology, cinema and theater studies, or relevant humanities and scientific disciplines from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 4 in the IELTS Academic test or equivalent, applicants holding a bachelor's degree in English are exempt from the language requirement.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 70,000',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Council of Joint Master\'s Program in Renewable Energy',
    program: 'MSc in Renewable Energy',
    discipline: 'Solar Energy Technology',
    requirements: `• Applicant must hold a full-time bachelor's degree in mechanical engineering, electrical engineering, chemical engineering, physics, or chemistry from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Council of Joint Master\'s Program in Renewable Energy',
    program: 'MSc in Renewable Energy',
    discipline: 'Wind Energy Technology',
    requirements: `• Applicant must hold a full-time bachelor's degree in mechanical engineering, electrical engineering, chemical engineering, physics, or chemistry from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Council of Joint Master\'s Program in Renewable Energy',
    program: 'MSc in Renewable Energy',
    discipline: 'Hydrogen Energy Technology',
    requirements: `• Applicant must hold a full-time bachelor's degree in mechanical engineering, electrical engineering, chemical engineering, physics, or chemistry from KSU or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Council of Joint Master\'s Program in Environmental Sciences',
    program: 'MSc in Environmental Sciences',
    discipline: 'Environmental Sciences',
    requirements: `• Applicant must hold a bachelor's degree in one of the scientific, health, or humanities disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR90,000',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Council of Joint Master\'s Program in Nanoscience and Applied Nanotechnology',
    program: 'MSc in Nanoscience and Applied Nanotechnology',
    discipline: 'Nanobiotechnology and Nanomedicine',
    requirements: `• Applicant must hold a full-time bachelor's degree in Physics, Chemistry, Chemical Engineering, Electrical Engineering, Pharmacy, Electronics and Communications Engineering, Clean Energy, Water Purification, Medical Diagnostics, Microbiology, Environmental Sciences, Biotechnology or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 4.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 90,000',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Council of Joint Master\'s Program in Nanoscience and Applied Nanotechnology',
    program: 'MSc in Nanoscience and Applied Nanotechnology',
    discipline: 'Nanomaterials and Nanodevices',
    requirements: `• Applicant must hold a full-time bachelor's degree in Physics, Chemistry, Chemical Engineering, Electrical Engineering, Pharmacy, Electronics and Communications Engineering, Clean Energy, Water Purification, Medical Diagnostics, Microbiology, Environmental Sciences, Biotechnology or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 4.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 90,000',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Council of Joint Master\'s Program in Biodiversity',
    program: 'MSc in Biodiversity',
    discipline: 'Biodiversity',
    requirements: `• Applicant must hold a full-time bachelor's degree in one of these disciplines: biology, environment, animal sciences, botany, microbiology, botany and microorganisms, rangelands, forests, plant production, animal production, plant protection, soil sciences, geography, chemistry, biochemistry, natural resources, food sciences, veterinary medicine, marine sciences, meteorology, environmental protection, or drugs -Pharmacy College- from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,000',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Council of Joint Master\'s Program in Public Health',
    program: 'Master of Public Health',
    discipline: 'Public Health',
    requirements: `• Applicant must hold a full-time bachelor's degree in medicine, dentistry, pharmacy, nursing, applied medical sciences, or relevant health disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS-Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Council of Joint Master\'s Program in Emergency and Disaster Management',
    program: 'Master in Emergency and Disaster Management',
    discipline: 'Emergency and Disaster Management',
    requirements: `• Applicant must hold a full-time bachelor's degree in any health, administrative, or related disciplines, from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) CGPA or equivalent. For related disciplines, the applicant must consult the concerned department before applying through the electronic portal.
• The qualification classification is considered by the Saudi Commission for Health Specialties if the program entry is a Bachelor's degree in Emergency Medical Services only.
• A score of at least 4.5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,000',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Council of Joint Higher Diploma in Radiation Protection and Safety of Radiation Sources',
    program: 'Higher Diploma in Radiation Protection and Safety of Radiation Sources',
    discipline: 'Radiation Protection and Safety of Radiation Sources',
    requirements: `• Applicant must hold a full-time bachelor's degree in medicine and surgery, engineering, science, pharmacy, applied medical sciences, nursing, agricultural engineering, or computer engineering from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) CGPA or equivalent. For related disciplines, the applicant must consult the concerned department before applying through the electronic portal.
• A score of at least 4 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 25,200',
  },
];

const graduate_programs_of_continuing_education_available_for_admission_2026_2027  = [
  // ==================== Humanities and Social Sciences ====================
  {
    college: 'Humanities and Social Sciences',
    department: 'Geography',
    program: 'Master of Arts in Geographical Information Systems',
    discipline: 'Geographical Information Systems',
    requirements: `• Applicant must have a bachelor's degree (regular or distance) in any humanities, scientific, engineering, or health disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; to identify the required discipline, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 84,000',
  },

  // ==================== Law and Political Science ====================
  {
    college: 'Law and Political Science',
    department: 'Political Science',
    program: 'Master of Arts in Political Science',
    discipline: 'Political Science',
    requirements: `• Applicant must hold a full-time bachelor's degree in political science, or relevant disciplines, from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 84,000',
  },
  {
    college: 'Law and Political Science',
    department: 'Public Law',
    program: 'Master of Law (Public Law)',
    discipline: 'Public Law',
    requirements: `• Applicant must hold a full-time bachelor's degree in law, rights, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• Passing a written examination, with a minimum success score of 40%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 108,000',
  },
  {
    college: 'Law and Political Science',
    department: 'Private Law',
    program: 'Master of Law (Private Law)',
    discipline: 'Private Law',
    requirements: `• Applicant must hold a full-time bachelor's degree in law, systems, Sharia, jurisprudence (Fiqh), judicial studies from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent.
• A score of at least 70 in the General Aptitude test or a score of 266 in the total of both sections of the GRE-General test.
• Passing a written examination, with a minimum success score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 108,000',
  },

  // ==================== Computer and Information Sciences ====================
  {
    college: 'Computer and Information Sciences',
    department: 'Computer Science',
    program: 'MSc in Artificial Intelligence',
    discipline: 'Artificial Intelligence',
    requirements: `• Applicant must hold a full-time bachelor's degree in computer science, IT, information systems, software engineering, computer engineering, non-educational computer disciplines, engineering, mathematics, or statistics and operations research, from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 4 in the IELTS-Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.
• A score of at least 70 in the General Aptitude Test (Quantitative Section) or at least 140 in the GRE-General test (Quantitative Section).`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 85,800',
  },
  {
    college: 'Computer and Information Sciences',
    department: 'Information Systems',
    program: 'MSc in Information Systems',
    discipline: 'Information Systems',
    requirements: `• Applicant must hold a full-time bachelor's degree in information systems, software engineering, computer sciences, computer engineering, IT, disciplines from the following colleges: (Engineering, Architecture and Planning, Science, Business Administration), or educational computer, from King Saud University or any accredited university, with a minimum of an "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Submitting a report of English proficiency test result.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 79,200',
  },
  {
    college: 'Computer and Information Sciences',
    department: "Council of Joint Master's Program in Cyber Security",
    program: 'MSc in Cyber Security',
    discipline: 'Cyber Security',
    requirements: `• Applicant must a full-time bachelor's degree in any scientific, health, humanities, or relevant disciplines, from King Saud University or any accredited university, with a minimum of a "Very Good" (3.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4 in the IELTS-Academic test or equivalent.
• A score of at least 65 in the General Aptitude Test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 86,400',
  },

  // ==================== Business Administration ====================
  {
    college: 'Business Administration',
    department: 'Public Administration',
    program: 'MSc in Public Administration',
    discipline: 'Public Administration',
    requirements: `• Applicant must hold a full-time bachelor's degree (regular or distance learning) in public administration, or relevant disciplines from KSU or any accredited university, with at least a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 65 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50%, held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,800',
  },
  {
    college: 'Business Administration',
    department: 'Health Administration',
    program: 'MSc in Health Administration',
    discipline: 'Health Administration',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree in relevant health, scientific disciplines, and from the humanities disciplines (psychology, social service, English language, literature and translation) from KSU or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.
• A score of at least 70 in the General Aptitude test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,800',
  },
  {
    college: 'Business Administration',
    department: 'Council of Graduate Programs in Business Administration',
    program: 'MSc in Business Administration',
    discipline: 'Business Administration',
    requirements: `• Applicant must hold a full-time bachelor's degree in business administration or relevant scientific, humanities, or health disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 6 in the IELTS Academic test or equivalent.
• A score of at least 65 in the General Aptitude test or equivalent.
• Applicant must submit the report of the GMAT test result.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 115,200',
  },
  {
    college: 'Business Administration',
    department: 'Quantitative Analysis',
    program: 'MSc in Decision Sciences',
    discipline: 'Decision Sciences',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in business administration, or relevant disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization.; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• A score of at least 70 in the General Aptitude test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,800',
  },
  {
    college: 'Business Administration',
    department: 'Management Information Systems',
    program: 'MSc in E-Business',
    discipline: 'E-Business',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance learning) in business administration or relevant scientific, health disciplines from KSU or any accredited university with a minimum of an "Good" (2.75/5) the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,800',
  },

  // ==================== Nursing ====================
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Nursing Administration',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• Passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 109,200',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Internal Surgical Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• Passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 109,200',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Childhood Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• Passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 109,200',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Psychiatric and Mental Health',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• Passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 109,200',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Community Health Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• Passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 109,200',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Primary care Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• Passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 109,200',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Maternal Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• Passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Female',
    tuition: 'SAR 109,200',
  },
  {
    college: 'Nursing',
    department: 'Council of Joint Graduate Programs in Nursing',
    program: 'MSc in Nursing',
    discipline: 'Midwifery Nursing',
    requirements: `• Applicant must hold a bachelor's degree in nursing from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent.
• A score of at least 4 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• A minimum of 1- years' experience.
• Passing a written examination held by the department.`,
    language: 'English',
    targetGroup: 'Female',
    tuition: 'SAR 109,200',
  },

  // ==================== Applied Medical Sciences ====================
  {
    college: 'Applied Medical Sciences',
    department: 'Community Health Sciences',
    program: 'MSc in Clinical Nutrition',
    discipline: 'Clinical Nutrition',
    requirements: `• Applicant must hold a full-bachelor's degree in clinical nutrition or relevant disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Obtainment of the occupational classification from the Saudi Commission for Health Specialties.
• Completion of the internship.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 80,600',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Clinical Laboratory Sciences',
    program: 'MSc in Clinical Laboratory Sciences',
    discipline: 'Medical Microbiology',
    requirements: `• Applicant must hold a full-time bachelor's degree in clinical laboratory sciences or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization., for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 101,400',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Clinical Laboratory Sciences',
    program: 'MSc in Clinical Laboratory Sciences',
    discipline: 'Medical Biochemistry',
    requirements: `• Applicant must hold a full-time bachelor's degree in clinical laboratory sciences or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization., for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 101,400',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Clinical Laboratory Sciences',
    program: 'MSc in Clinical Laboratory Sciences',
    discipline: 'Hematology and Serology',
    requirements: `• Applicant must hold a full-time bachelor's degree in clinical laboratory sciences or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent; Or with a "Pass" of (2/5) GPA with a higher diploma with an "Excellent" (4.5/5) GPA or equivalent., in the program's specialization., for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 101,400',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Radiological Sciences',
    program: 'MSc in Radiological Sciences',
    discipline: 'Radiation Protection',
    requirements: `• Applicant must hold a full-time bachelor's degree in radiological sciences, diagnostic imaging technique, or x-ray and medical imaging, medical physics, or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent.
• Applicant with medical physics degree can apply only for Radiation Protection.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Completion of the internship, or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 108,800',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Radiological Sciences',
    program: 'MSc in Radiological Sciences',
    discipline: 'Nuclear Medicine and Molecular Imaging',
    requirements: `• Applicant must hold a full-time bachelor's degree in radiological sciences, diagnostic imaging technique, or x-ray and medical imaging, medical physics, or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Completion of the internship, or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 108,800',
  },
  {
    college: 'Applied Medical Sciences',
    department: 'Radiological Sciences',
    program: 'MSc in Radiological Sciences',
    discipline: 'MRI Techniques',
    requirements: `• Applicant must hold a full-time bachelor's degree in radiological sciences, diagnostic imaging technique, or x-ray and medical imaging, medical physics, or relevant disciplines from King Saud University or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent.
• Certificate obtained from abroad must be accredited according to the equivalency program provided by the Ministry of Education.
• A score of at least 5 in the IELTS Academic test or equivalent.
• Completion of the internship, or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 108,800',
  },

  // ==================== Deanship of Graduate Studies - Interdisciplinary and Joint Programs ====================
  {
    college: 'Deanship of Graduate Studies',
    department: "Council of Joint Master's Program in Environmental Sciences",
    program: 'MSc in Environmental Sciences',
    discipline: 'Environmental Sciences',
    requirements: `• Applicant must hold a bachelor's degree in one of the scientific, health, or humanities disciplines from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 92,400',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: "Council of Joint Master's Program in Public Health",
    program: 'Master of Public Health',
    discipline: 'Public Health',
    requirements: `• Applicant must hold a full-time bachelor's degree in medicine, dentistry, pharmacy, nursing, applied medical sciences, or relevant health disciplines from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A score of at least 6 in the IELTS-Academic test or equivalent.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 88,400',
  },
];

const EXECUTIVE_PROFESSIONAL_MASTER_2026_2027 = [
  // ==================== Humanities and Social Sciences ====================
  {
    college: 'Humanities and Social Sciences',
    department: 'Social Studies',
    program: 'Executive Master in Social Work',
    discipline: 'Social Work',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance) in social studies, social service, or sociology from KSU or any accredited university, with a minimum of an "pass" (2 /5) GPA or equivalent.
• A minimum of 2 years' experience.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 66,000',
  },
  {
    college: 'Humanities and Social Sciences',
    department: 'Social Studies',
    program: 'Executive Master in Family Counselling',
    discipline: 'Family Counselling',
    requirements: `• Applicant must hold a bachelor's degree (full-time or distance learning) in sociology, social work, psychology, education, anthropology, kindergarten, Business Administration, Islamic law (Shari'a), law, or mass media from King Saud University or any accredited university, with a minimum of a 2 out of 5 CGPA or equivalent.
• Note: According to the program's criteria, the classification issued by the Ministry of Human Resources and Social Development for this degree is available only to holders of a bachelor's degree in the following disciplines: Sociology, Social Work, or Psychology.
• Applicant must have a minimum of 2 years of experience.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 66,000',
  },

  // ==================== Tourism and Archeology ====================
  {
    college: 'Tourism and Archeology',
    department: 'Tourism and Hotel Management',
    program: 'Executive Master in Tourism and Hospitality',
    discipline: 'Tourism and Hospitality',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree in science, health, or humanities disciplines from KSU or any accredited university, with a minimum of a "pass" (2/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A minimum of 2 years' experience.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 79,200',
  },

  // ==================== Sport Sciences and Physical Activity ====================
  {
    college: 'Sport Sciences and Physical Activity',
    department: 'Sports and Recreation Management',
    program: 'Executive Master in Sports and Recreation Management',
    discipline: 'Sports and Recreation Management',
    requirements: `• Applicant must hold a bachelor's degree (full-time/distance) in sport sciences and physical activity or relevant disciplines from King Saud University or any accredited institution with a minimum of a "Pass" (2/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A minimum of 2 years' experience.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 79,200',
  },

  // ==================== Science ====================
  {
    college: 'Science',
    department: 'Joint Program Council in Pure Forensic Sciences',
    program: 'Executive Master in Forensic Pure Science',
    discipline: 'Forensic Pure Science',
    requirements: `• Applicant must hold a bachelor's degree (full-time/distance) in science, health, humanities, or any relevant disciplines from King Saud University or any accredited institution with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A minimum of 2 years' experience.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 66,000',
  },
  {
    college: 'Science',
    department: 'Joint Program Council in Environmental Impact Assessment',
    program: 'Executive Master in Environmental Impact Assessment',
    discipline: 'Environmental Impact Assessment',
    requirements: `• Applicant must hold a full-time bachelor's degree in relevant scientific, health, disciplines from King Saud University or any accredited institution with a minimum of a "Pass" (2/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A minimum of 2 years' experience.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 77,000',
  },

  // ==================== Computer and Information Sciences ====================
  {
    college: 'Computer and Information Sciences',
    department: 'Information Systems',
    program: 'Executive Master in Data Science and Management',
    discipline: 'Data Science and Management',
    requirements: `• Applicant must hold a full-time bachelor's degree in computer and information science, business administration, engineering, or science from KSU or any accredited university, with a minimum of a "Good" (2.75/5) CGPA or equivalent. For related disciplines, the applicant must contact the concerned department/program before starting the application process.
• Submission a report of an English proficiency test.
• Applicant must have at least two years of experience.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 85,800',
  },

  // ==================== Business Administration ====================
  {
    college: 'Business Administration',
    department: 'Public Administration',
    program: 'Executive Master of Public Administration',
    discipline: 'Public Administration',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree in public administration or any discipline from KSU or any accredited university, with at least a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A minimum of 3 years' experience.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 100,800',
  },
  {
    college: 'Business Administration',
    department: 'Public Administration',
    program: 'Executive Master in Governance and Public Policies',
    discipline: 'Governance and Public Policies',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree any scientific, health, humanities, or relevant disciplines any scientific, health, humanities, or relevant disciplines from KSU or any accredited university, with at least a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A minimum of 3 years' experience.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 93,600',
  },
  {
    college: 'Business Administration',
    department: 'Finance Administration',
    program: 'Executive Master in Finance',
    discipline: 'Finance',
    requirements: `• Applicant must hold a bachelor's degree in (Business Administration, Science, Computer and Information Science, Engineering) from KSU or any accredited university, with a minimum of a "Pass (2/5) GPA" or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Submission a report of an English proficiency test.
• A minimum of 3 years' experience.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 72,000',
  },
  {
    college: 'Business Administration',
    department: 'Finance Administration',
    program: 'Executive Master in Financial Technology and Innovation',
    discipline: 'Financial Technology and Innovation',
    requirements: `• Applicant must hold a bachelor's degree in (Business Administration, Science, Computer and Information Science, Engineering) from KSU or any accredited university, with a minimum of a "Pass (2/5) GPA" or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• Submission a report of an English proficiency test.
• A minimum of 3 years' experience.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 93,600',
  },
  {
    college: 'Business Administration',
    department: 'Health Administration',
    program: 'Executive Master in Health Administration',
    discipline: 'Health Administration',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree in relevant health, scientific disciplines, and from the humanities disciplines (psychology, social service, English language, literature and translation) from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 5 in the IELTS Academic test or equivalent.
• A minimum of 2 years' experience.
• Passing a written examination, with a minimum score of 40% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 86,400',
  },
  {
    college: 'Business Administration',
    department: 'Economics',
    program: 'Executive Master in Economics',
    discipline: 'Economics',
    requirements: `• Applicant must hold a full-time bachelor's degree in economics or any relevant disciplines from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A minimum of 2 years' experience.
• Passing a written examination, with a minimum score of 50% held by the department.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 72,000',
  },
  {
    college: 'Business Administration',
    department: 'Council of Joint Master Program Council in Business Administration',
    program: 'Executive Master of Business Administration',
    discipline: 'Business Administration',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree in any scientific, health, humanities, or relevant disciplines from KSU or any accredited university, with a minimum of a "Above Average" (3.25/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• Applicant must provide evidence of holding a previous/current leading role or candidate for one, from current employer.
• A score of at least 6 in the IELTS Academic test or equivalent.
• A minimum of 3 years' experience.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 103,200',
  },
  {
    college: 'Business Administration',
    department: 'Administration',
    program: 'Executive Master in Human Resources',
    discipline: 'Human Resources Management',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree in relevant administrative, scientific, health, or humanity disciplines, from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• A minimum of 3 years' experience.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 93,600',
  },
  {
    college: 'Business Administration',
    department: 'Joint Program Council in Insurance',
    program: 'Executive Master of Insurance',
    discipline: 'Insurance',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree in science, health, or business administration disciplines from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• A minimum of 3 years' experience.`,
    language: 'Arabic- English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 86,400',
  },
  {
    college: 'Business Administration',
    department: 'Joint Program Council in Business Analytics',
    program: 'Executive Master of Business Analytics',
    discipline: 'Business Analytics',
    requirements: `• Applicant must hold a full-time/distance bachelor's degree in science, health or business administration disciplines from KSU or any accredited university, with a minimum of an "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• A minimum of 2 years' experience.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 86,400',
  },

  // ==================== Pharmacy ====================
  {
    college: 'Pharmacy',
    department: 'Joint Program Council in Drug Regulatory Affairs',
    program: 'Executive Master of Drug Regulatory Affairs',
    discipline: 'Drug Regulatory Affairs',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmacy, pharmaceutical sciences or a Pharm. D. from KSU or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent.
• Submission a report of an English proficiency test.
• A minimum of 2 years' experience.
• Passing a written examination, with a minimum score of 25% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 86,400',
  },
  {
    college: 'Pharmacy',
    department: 'Joint Program Council in Forensic Toxicology',
    program: 'Professional Master in Forensic Toxicology',
    discipline: 'Forensic Toxicology',
    requirements: `• Applicant must hold a full-time bachelor's degree in pharmaceutical sciences or a Pharm. D., or applied medical sciences (medical laboratories), medicine and surgery, dentistry, or nursing from KSU or any accredited university, with at least a "Good" (2.75/5) GPA or equivalent; for relevant disciplines, the applicant must refer to the concerned department before starting the application process on the electronic portal.
• A score of at least 4.5 in the IELTS Academic test or equivalent.
• Passing a written examination, with a minimum score of 50% held by the department.
• A minimum of 2 years' experience.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 88,800',
  },

  // ==================== Applied Medical Sciences ====================
  {
    college: 'Applied Medical Sciences',
    department: 'Community Health Sciences',
    program: 'Executive Master in Health Promotion and Education',
    discipline: 'Health Promotion and Education',
    requirements: `• Applicant must hold a regular bachelor's degree in any health disciplines or relevant disciplines from KSU or any accredited institution, with a minimum of a "Pass" (2.75/5) GPA or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A minimum of 2 years' experience.
• Passing a written examination, with a minimum success score of 50% held by the department.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 86,400',
  },

  // ==================== Deanship of Graduate Studies - Interdisciplinary and Joint Programs ====================
  {
    college: 'Deanship of Graduate Studies',
    department: 'Joint Program Council in Justice Administration',
    program: 'Executive Master in Justice Administration',
    discipline: 'Justice Administration',
    requirements: `• Applicant must hold a bachelor's degree (regular or distance) in any scientific, health, humanities, or relevant disciplines from KSU or any accredited institution, with a minimum of a "Pass (2/5) GPA" or equivalent; for relevant disciplines, applicant must refer to the concerned department before starting the application process.
• A minimum of 2-years' experience in the field of specialization.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 96,600',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Joint Program Council in Taxation Law',
    program: 'Executive Master of Taxation Law',
    discipline: 'Taxation Law',
    requirements: `• Applicant must hold a full-time bachelor's degree in law, regulations, rights, or accounting from King Saud University or any accredited university, with a minimum of a "Good" (2.75/5) GPA or equivalent.
• Applicant must have a minimum of two-year work experience.`,
    language: 'Arabic',
    targetGroup: 'Male- Female',
    tuition: 'SAR 86,000',
  },
  {
    college: 'Deanship of Graduate Studies',
    department: 'Joint Program Council in Digital Transformation',
    program: 'Executive Master in Digital Transformation',
    discipline: 'Digital Transformation',
    requirements: `• The applicant must have a bachelor's degree in any of the administrative, engineering, scientific, health, or humanities disciplines from King Saud University or any other accredited institution, with a grade of at least "Good" and a cumulative GPA of (2.75/5) or equivalent. "The applicant must contact the concerned academic department/program to verify whether his specialization is among the required disciplines prior to applying through the electronic admission portal."
• A minimum score of 5 on the IELTS ACADEMIC test or its equivalent.
• The applicant must have no less than three years of experience in the fields of business, technology, administration, strategy, or digital innovation.`,
    language: 'English',
    targetGroup: 'Male- Female',
    tuition: 'SAR 86,400',
  },
];

export const PROGRAM_EXCEL_FILTERS = [
  {
    id: 'regular-graduate',
    filterLabel: 'Regular graduate (2026/2027)',
    sectionTitle:
      'Regular graduate programs available for admission in the (2026/2027 AD) 1448 AH academic year',
    rows: REGULAR_GRADUATE_2026_2027,
  },
  {
    id: 'graduate_programs_of_continuing_education',
    filterLabel: 'Graduate programs of continuing education',
    sectionTitle:
      'Graduate programs of continuing education available for admission in the (2026/2027 AD) 1448 AH academic year',
    rows: graduate_programs_of_continuing_education_available_for_admission_2026_2027,
  },
  {
    id: 'executive_professional_master',
    filterLabel: 'Executive professional master',
    sectionTitle:
      'Executive professional master programs available for admission in the (2026/2027 AD) 1448 AH academic year',
    rows: EXECUTIVE_PROFESSIONAL_MASTER_2026_2027,
  },
];